export default `
Zer'Chi,Changling,Arcane Trickster
Myrrin Farhaven,Human,Paladin
Tsar,Elf,Wizard
Nerisia,Elf,Druid
Tsar,Elf,Wizard
Tsar,Elf,Wizard
Nim'bellis Thorngage,Halfling,Fighter
Rella Autumnleaf,Halfling,Druid
Quincy,Ratfolk,Rogue
Nimbly,Human,Barbarian
Rosemary Cresent,Half-Elf,Fighter
Suvana,Half-elf,Warlock
Nim,Ratfolk,Bard
Girlifer,Half-orc,Barbarian
Grak mol Mak,Goblin,Wizard
Grak Moor,Goblin,Warrior
Ragna,Half-Orc,Barbarian
Velethuil'adar Melpenn,High Elf,Wizard
Ilsa Tealeaf,Halfling,Rogue
Oromis,Half-Elf,Ranger
Lem,Halfling,Cleric
Shalka the Lightning Bright,Half-Elf,Wizard
Shalka the Lightning Bright,Half-Elf,Cleric
J'Karr Bordell,Half-Orc,Fighter
Thyra,Half-elf,Bard
arrbark,Revenant,Witch
arrhylia,Drow,Rogue
Kazar Killgotth,Dwarf,Fighter
Tammulin Coldwater,Human,Wizard
Sjach,Scourge Aarj,Bard
Tammulin Coldwater,Human,Fighter
ThagarSlimegut,Drow,Bard
Nim,Half-elf,Bard
Huzzan,Human,Bard
Thud,Half-orc,Barbarian
Eepirk,Elf,Swashbuckler
Xiella,Elf,Magic Scholar
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Saegar Deadshot,Dwarf,Fighter
Nowhere,Elf,Warlock
Erk,Half-orc,Barbarian
Aaronsa,Elf,Ranger
Finneas Wittle,Human,Bard
David Parrish,Human,Rogue
David O'Bannon,Human,Fighter
David O'Bannon,Human,Fighter
Little John,Samsaran,Cleric
David Parrish,Human,Fighter
David O'Bannon,Human,Fighter
David O'Bannon,Human,Fighter
Little John,Samsaran,Cleric
David O'Bannon,Human,Fighter
Glenn,Human,Ranger
Esgar,Human,Fighter
Tei that laughs,Longtooth shifter,Multiclass
Hugo of the mushrooms,Gnome,Rogue
Irsan,Human,Wizard
Hugo of the mushrooms,Gnome,Rogue
Apollo Armpit,Halfling,Monk
Soggy Paws,Half-elf,Paladin
Apollo Armpit,Halfling,Monk
Apollo Armpit,Halfling,Monk
Apollo Armpit,Halfling,Monk
Apollo Armpit,Halfling,Monk
Apollo Armpit,Halfling,Monk
Apollo Armpit,Halfling,Monk
Apollo Armpit,Halfling,Monk
Flying Dog,tabaxi,fighter
Adolf Lavellan,Human,Fighter
Clay,Kender,Thief
Adolf Lavellan,Human,Fighter
Clay,Kender,Thief
Adolf Lavellan,Human,Fighter
Fang,half-orc,bard
Adolf Lavellan,Human,Fighter
Crenko,Half-elf,Rogue
Elaine,Human,Fighter
Naenia,Half-elf,Bard
Maldri Lionspeaker,halfling,fighter
Maldwin,half-elf,fighter
Sinead,Halfling,Rogue
Argan,Half Orc,Paladin
Human,Thief
Tamsyn Syndorne,Half-Elf,Cleric
Krieg,Dwarf,Fighter
Ricilan Fargo,Human,Thief
Sage,Half Elf,Rogue
Vellynn Sarhia,Variant Human,Cleric
Balthazar the Unwise,Human,Magic User
Gragnak the Uncaring,"Half orc, half elf"
UThrac,Half-Orc,Magic User
Zhaudan,Dragonborn,Sorcerer
Vex'ahlia,Variant Human,Fighter
Celdor Aras III,Half-Orc,Magic User
Varis,Elf,Magus
Aeran,Elf,Magus
Tansy Yar,Catfolk,Rogue
Olan Redpipe,Dwarf,Wizard
Nerimys Arkwalker,Dragonborn,Sorceror
David,Human,Warlock
Engir,Elf,Fighter
Bronn,Dwarf,Cleric
Amanal,Human,Ranger
Anril,Elf,Ranger
Aldorum,Human,Paladin
Kerrek,Dwarf,Paladin
Killeff,Half-Elf,Warlock
Amaranthe,Elf,Wizard
Mallory,Human,Cleric
Threk Goblinhater,Gnome,Illusionist
Alicia Silverglade,Half-elf,Sorcerer
Rhogar Delmirev,Dragonborn,Sorcerer
Bartholomew Kuttner,Human,Ranger
Adradorite,Dragonborn,Wizard
H'kiera,Dragonborn,Paladin
Arid Silverleaf,Elf,Fighter
Arelkya,Dragonborn,Cleric
Kyla,Human,Bard
Arelkya,Dragonborn,Cleric
Fia,Human,Ranger
Aveline,Human,Wizard
Redlen,Human,Fighter
Uriel,Human,Paladin
Darianna,Human,Bard
Thrak,Orc,Fighter
Glyngolor,Half-Elf,Rogue
Gabriel,Human,Paladin
Zoltar,Human,Wizard
Tobor Atellar,Half-Elf,Bard
Human,Fighter
Aela,Half-elf,Paladin
Hokinger,Human,Assassin
Burlok,Dwarf,Fighter
Lucille,Human,Warlock
Rehrin Smeltz,Gnome,Rogue
Grundella Proudfoot,Halfling,Fighter
Karagor Na•lo,Elf,Rogue
Grrrvalley Gritchrit,Orc,Barbarian
Fy'erelda,Elf,Ranger
Takumo Nara,Human,Monk
Kroklo,Human,Ardent
balasar,dragonborn,wizard
Caliper,Half-Elf,Ranger
Alborin Frostbeard,Dwarf,Cleric
Pak Firetow,Human,Barbarian
Engenditha Flomen,Human,Bard
Englis Thorncrow,Half-Elf,Rogue
Cricket Trickfoot,Halfling,Thief
Faelin Aulind,Aasimar,Cleric
Takumo Nara,human,cleric
Mildra,Human,warlock
Alaric Veneno,Human,Ranger
Geth the Invoker,Human,Ranger
Ran Firebrand,Human,Ranger
Ankle Spots on your Pants,Gnome,Bard
Englis Thorncrow,Half-Elf,Rogue
It's a Racket,Human,Ranger
Valor,Half-Orc,Temple Cleric
Delphinium,Human,Paladin
Aeshkan,Half-Elf,Bard
Doudicpargh,Hobgoblin,Mystic
�furtrath,Human,Paladin
Khldaard Bouchard,Half-elf,Bard
Saurladion,Half-Elf,Bard
Bouchard,Half-Elf,Rogue
Ailrich Edmundson,Halfling,Fighter
Kethra Kadent,Human,Fighter
Lark,Dragonborn,Druid
Romeo ,Druid
Brieizing Brewsman,Half orc,Monk
Aranel,Elf,Ranger
Roamar,Elf,Rogue
Andry Levesque,Human,Rogue
Roastre,Half-elf,Bard
"Freddy ""Flash"" Allen",Human,Ranger
Razi Nobel,Human,Warlock
Honor Redhawk,Half-orc,Fighter
Furgurg Holder,Half-Orc,Cleric
Lerion,Aasimar,Bard
Mael Stromm,Human,Wizard
Mistral,Human,Barbarian
Maelstrom,Tiefling,Warlock
Daegarth Ungart,Half-Orc,Fighter
Wu Wei,Human,Monk
Kirera T'ranek,Dragonborn,Paladin
Isobel Scarnetti,Half elf,Druid
Nevarion Hayford,Human,Artificer
Adrea Decarone,Human,Bard
Mercy,Tiefling,Fighter
Hrywulg,Human,Fighter
Uriza Wolf-Blood,Dragonborn,Fighter
Feng Xiao,Halfling,Rogue
Hwei being Tiefling,Gnome,Fighter
Deian Torres-Ortega,Human,Fighter
Huo Tianning,Half-Elf,Fighter
Solomon,Human,Wizard
Feng Xiao,Halfling,Rogue
Hui Bloodhoof,Dragonborn,Paladin
Ara,Human,Cleric
Jin-Thi Ban,Human,Monk
Jin-Thi Ban,Human,Monk
Kyari,Human,Rogue
Raisha Rachiina,Halfling,Rogue
Kyari,Human,Rogue
Wyvern,Aasimar,Cleric
Forge,human,wizard
Wyvern,Aasimar,Cleric
Donovan Shoasell,Orc,Brawler
Maedon Tekka a**gonizzutte,Gnome,Wizard
Donovan Shoasell,Human,Cleric
Donovan Shoasell,Human,Cleric
Donovan Shoasell,Human,Cleric
Jamie Whitehead,Human,Cleric
Yvette Dhekhar,Human,Barbarian
Henderson,Human,Fighter
Quinn,Human,Ranger
Bella,Human,Rogue
Bloople,Human,Fighter
Kender Blueskull,Half-orc,Fighter
Cerise Underbough,Halfling,Druid
Bryce,Human,Rogue
Lola Slaptrap,Half-elf,Bard/Rogue
Mississippi Longtenbell,Halfling,Bard
Nina Fey,Human,Bard
Shaelin Shatre,Half-Elf,Bard
Harranek,Dragonborn,Monk
Aeyla,Half-elf,Bard
Corvus Shatre,Half-Elf,Paladin
Mississippi Blu Lightfoot,Halfling,Fighter
Valandil Surk,Half-Orc,Bard
Meridash Tumbly,Halfling,Sorcerer
Aurith Kuldotha,Half-Elf,Bard
Dreigh,Half-Orc,Paladin
Quinlan,Half-elf,Fighter
Dairgen,Half-elf,Rogue
Wyndfyll,Half-elf,Ranger
Agrona,Half-Elf,Sorcerer
Maleder,Half-elf,Paladin
Wyndfyll,Half-elf,Ranger
Agatha,Half-elf,Druid
Myrtle,Half-ling,Wizard
Wyndfyll,Half-ling,Ranger
Fidget,Halfling,Bard
Gwenll Nightshade,Half-elf,Wizard
Griddle C. Gorgias,Halfling,Druid
Wyndfyll,Half-ling,Ranger
Ildefons,Halfling,paladin
Mina,Half-Orc,witch
Bartholomew Hackwater,Halfling,Fighter
Rufus Rumaila,Half-Orc,Witch
Fiona,Half-Orc,Druid
Irian Plains,Half-elf,Bard
Mordrid,Half-Orc,Witch
Jason Woodings,Halfling,Fighter
Kon,Half-Orc,Fighter
Teagan Cordelia Yavuz,Half-Orc,Witch
Karsus,Half-Elf,Rogue
Mara,Half-Elf,Bard
Yorrin Weaver,Half-Elf,Cleric
Elyon R'steef,Half-elf,Bard
Skeld,Human,Monk
The sceptre of Xbah'pu,Tiefling,Warlock
Luathin,Elf,Fighter/Wizard
Abbot,Human,Ranger
Galen,Human,Cleric
Alexei Maelstrovich,Human,Cleric
Torch,Tiefling,Monk
Hrun,Half-orc,Barbarian
Anastrial Holimion,Elf,Ranger
Tansy Willowherb,Wood elf,Ranger
Dorian,Human,Fighter
Tanketune,Dwarf,Fighter
Horchata Absianson,Elf,Sorcerer 
Reidan Torech,Half-Elf,Paladin
Boltikar,Human,Fighter
Sowilo,Orc,Fighter
Nevitash Arcanum,Dwarf,Bard
Zanna,Human,Fighter
Tansy Willowherb,Wood elf,Ranger
Hrun,Half-orc,Barbarian
Anzo Leuke,Human,Fighter
Solakotel,High elf,Wizard
Eru,Elf,Bard
Axel,Human,Fighter
Skeld,Human,Rogue
Bourbon,Human,Barbarian
Auric Emberlash,Dwarf,Rogue
Urdos Wer J'nah Pisans,Human,Bard
Axel Greyskull,Dwarf,Wizard
T'hifer Hadzi,Gnome,Wizard
Machiave,Dwarf,Berserker
Thernys Ciaphal,Dragonborn,Cleric
Mardrede,Elf,Cleric
Grizeit,Dwarf,Berserker
Ardashir Talonsegel,Drow,Cleric
Del Coyle,Human,Paladin
Mann †r,Dwarf,Fighter
Mera,Half elf,Paladin
Evendur Stormwind,Human,Fighter
Zz'asimz †Š's,Half orc,Fighter
N'lorin Arden,1uer,Sorcerer
Emmet,Human,Fighter
Malevolent,Krugan,Rogue
Fear,Changeling,B
Starbuck,Human,Wizard
Aza,Human,Fighter
Buber,Half-Elf,Cleric
Brunde,human,sorceror
Brunde,human,sorcerer
Crenn,human,ranger
Ulfgar,dwarf,fighter
Murray,human,barbarian
Nessarr,drow elf,rogue
Nessarr,drow elf,rogue
Ardent,human,bard
Pyke Galrin,gnome,wizard
Ioda,human,fighter
Ioda,human,cleric
Rin Kurome,human,fighter
Pyke Galrin,gnome,wizard
Ioda,human,ranger
Alena,human,fighter
Noodlearms,Robot,wizard
Noodles,Human,Rogue
Merenghi,galanodel,wizard
Owl,Halfling,Rogue
Gheed,Half-orc,Tempest Cleric
Thagana,Human,Tempest Cleric
Khulger,Dragonborn,Monk
Delirhia,Human,Tinker
Hrolgrun,Human,Quellar Warlock
Lia Kokoro,Human,Warlock
Astrid,Human,Necromancer
Benkei,Human,Knight
Larissa,Human,Ranger
Gil,Human,Wizard
Ludwig,Human,Barbarian
Yan,Human,Warlock
Phinmun,Changeling,Bard
Arleian,Dwarf,Paladin
Radagast,Human,Wizard
Aovic,Human,Ranger
Skellum,Human,Rogue
Ludwig,Human,Paladin
Mich Brody,Human,Wizard
Lilly,Dwarf,Fighter
Albany,Elf,Ranger
Aeyla,Elf,Monk
Cosanne Sloan,Human,Cleric
DQ Wyn Ree,Human,Druid
Kyren Gurmudger,Dwarf,Fighter
Atziri,Dwarf,Bard
Gauvith,Goliath,Ranger
N'loriy,Dragonborn,Warlock
Llyrth Reshwoodson,Human,Wizard
Thogra,Half-Orc,Fighter
Aerilynath,Tiefling,Warlock
Omnarath Daerora,Dragonborn,Druid
Hemlern Longmire,Human,Paladin
"Wilhelmina ""Billy"" Mheneth",Drow elf,Fighter
Beedle son of Baldrick,Hafling,Bard
Hymn,Lizardfolk,Ranger
Squeak orphilia,Goblin,Barbarian
Scred,Catfolk,Alchemist
Zarquon Arquonk,Half Elf,Sorcerer
"Bill ""Bird"" Roth",Rock Gnome,Wizard
Arquen,Half-Elf,Sorcerer
Hymn,Lizardfolk,Rogue
Squeak,Goblin,Barbarian
Drys,Half-orc,Barbarian
Arquen,Half-Elf,Sorcerer
Ong Rusa,Human,Ranger
Bill Finger,Human,Fighter
Ong Rheem,Wood elf,Monk
Impact,Genasi,Sorcerer
Bhrgha,Dwarf,Druid
Thorn Beakwood,Tengu,Shaman
Mrwaith,Elf,Rogue
Bhrutgh Ragnar Nagors,Half-orc,Fighter
Ghost,Half-Orc,Templar
Thorn Beakwood,Tengu,Shaman
Bhrutors,Half-Orc,Templar
Emmet,Human,Fighter
Valtor,Tiefling,Wizard
Valtor Outran,Half-Orc,Fighter
Valtor Kulak,Half-Orc,Fighter
Serben,Half-Orc,Fighter
Chen,Half-Orc,Fighter
Saegro,Half-orc,Wizard
Falcon Pennywise,Halfling,Bard
Polly JŸrer,Half-Orc,Fighter
Frumin,Half-Orc,Wizard
Aukan the Pied-de-Vickel,Halfling,Bard
Anguis Mortis,Human,Fighter
Bill Nastar,Chgian,Mage
Gyal Mist
Dramatrix Ravenus,Human,Wizard
Bryn Alamilla,Human,Cleric
Morithir Carrion,Elf,Sorcerer
Aturin Mistshadow,Elf,Fighter
Baloria,Hafling,Bard
Copenhine Oxoshaft,Dwarf,Wizard
Kaldrigon,Human,Rogue
Nyamhion,Elf,Ranger
Morithir,Elf,Fighter
Orode,Tiefling,Rogue
Craxis,Elf,Ranger
Malkus Stormchild,Half-Elf,Sorcerer
Feykro Stonebreaker,Dwarf,Fighter
Hagron Ashgun,Dwarf,Fighter
Oleandra Armassian,Human,Paladin
Uni Larpringl,Halfling,Wizard
Marl Gothin,Human,Fighter
Husk,Human,Cleric
Merielein,Elf,Rogue
Wynnter Logan,Human,Fighter
Thamrin Teulath,Elf,Ranger
Sivven the Mouse,Ratfolk,Alchemist
Rakhar Ironfur,Dwarf,Cleric
Darnil,Ratfolk,Warlock
Lucan Greywood,Human,Wizard
Amea Bransfeld,Human,Rogue
Zaccaria,Half-Elf,Bard/Warlock
Rakdril Kalamdar,Half-Elf,Ranger
Alexander Stonerender,Dwarf,Cleric
Asvar the Rat,Half-Orc,Barbarian
Nasmari,Elf,Wizard
Shardra Geltar,Half-Elf,Ranger/Paladin
Ergo,Gnome,Wizard
Khoda,Half-orc,Barbarian
Therumnara,Human,Cleric
Maedhra,Elf,Ranger
Iala,Half-Elf,Bard
Erdan,Elf,Paladin
Arja Ironjaw,Halfling,Rogue
GrshtQuickdraw,Gnome,Wizard
Tiimjarle,Human,Ranger
Zeth,Human,Rogue
Maximus,Human,Wizard
Bree Goodbarrel,Halfling,Fighter
Diana Wynne Quinn
Illumines,Human,Fighter
Trixiell Quicksilver,Elf,Wizard
Miri,Drow,Warlock
Kirin Ironfist,Dwarf,Monk
Birgev Outlander,Human,Ranger
Glyngolor,Half-Elf,Bard
Golinder Stoneheart,Gnome,Fighter
Birgev Irimblestar,Human,Fighter
Golnok,Dwarf,Fighter
Solnira Stronginthearm,Dwarf,Cleric
Arn Breaker,Half-Orc,Barbarian
Brizzo Vibrantusk,Gnome,Ranger
Ruthiesword,Pixie,Bard
Noster,Half-elf,rogue
Mara Union,Half-Elf,Monk
Raz,Half-Orc,Cleric
Enok,Half-Elf,Monk
Dancer,Half-Elf,Monk
Rajihra,Wood Elf,Monk
Belathu Valkar,Half-Elf,Sorcerer
Feal,Tiefling,Bard
Chakna,Tiefling,Bard
Keith,Kenku,Bard
Melisandra,Human,Bard
Valkryr,Half-Elf,Paladin
Vanu Dragonsbane,Human,Barbarian
Tallahan Biryhrolla,Half-Elf,Sorcerer
Hybris Sun'srah,Human,Fighter
Pyrian,Dragonborn,Warlock
Vanu Dragonsbane,Human,Barbarian
Tallahan Biryhrolla,Half-Elf,Sorcerer
Dea Sunblade,Orc,Barbarian
Tallahan Biryhrolla,Half-Elf,Sorcerer
Dea Sunblade,Orc,Barbarian
Nova,Firbolg,Ranger
Keet Dynamo Pity,Teifling,Ranger
Engin Wright,Human,Warlock
Orgn. Jockel,Rolling Thunder,Monk
Aerin,Drow,Ranger
Krekk Gait,Half-Orc,Fighter
Jeffy Gunn,Human,Fighter
Ailwin Hedges,Halfling,Ranger
Lompond
The Bear,Half-orc,Paladin
Barro,Dwarf,Fighter
Berenger,Half-elf,Druid
Breeze,Human,Monk
Treonfier,Half-elf,Bard
Brine,Half-Orc,Barbarian
Tamen Brightblade,human,energy manipulator
Yajirobe,Human,Swashbuckler
Kieran,half elf,warlock
Peregrine Wingfield,Human,Sorcerer
Nova Delamari,Elf,Wizard
Annaleath,Elf,Ranger
Atziri,Eladrin,Wizard
Jasper,Human,Monk
Nova Delamari,Elf,Warlock
Pumpkin,Halfling,Ranger
Celia,Human,Ranger
Atziri,Eladrin,Wizard
Eldarin Ulthran,Human,Druid
Stroek,Ratfolk,Druid
Kerri Orelsis,Human,Rogue
Kethra,Human,Paladin
Risal,Half-elf,Rogue
Kerri Orelsis,Human,Rogue
Benevolence Ranrek,Tiefling,Cleric
Mordrid,Human,Wizard
Lara Hudson,Halfling,Sorcerer
Sazerac,Dragonborn,Monk
Cyrina Pedderee,Halfling,Cleric
Gabriel McDowell,Human,Fighter
Tahar Navar,Half-elf,Warlock
Blake Grimnivs,Human,Ranger
Arcuna,Half-elf,Warlock
April Sunless,Halfling,Rogue
Eva,Human,Wizard
Alexander,Human,Sorcerer
Jordan Quickheel,Human,Bard
DJ- Callie,Little Casey,Full of Beans and Nails
Ellathar Nodellari,Human,Wizard
Kozell,Half-orc,Fighter
Udax,Half-Orc,Barbarian
Udgar,Goblin,Fighter
Solomon,Human,Wizard
Dur Kedinn,Half-orc,Monk
Gavril,Dwarf,Rogue
Nadya,Aasimar,Paladin
Vicktor,Dwarf,Cleric
Astrid,Human,Bard
Roxanne Murch,Human,Fighter
Nara,Half-Elf,Sorcerer/Rogue
Konrad,Half-Elf,Warlock
Morriel,Half-Elf,Sorcerer/Warlock
Consent Alabama Rieda,Half-Elf,Cleric
Margeulis Daye,Half-Elf,Bard
Johnna Gilly,Half-Elf,Druid
Magnus Burnsides,Half-Elf,Fighter
Ed Cullen,Half-Elf,Ranger
Fian�n Hazard,Half-Elf,Sorcerer
Fenrir,Half-Elf,Druid
Hans de Bardo,Half-Elf,Warrior
Ehrbir Fellblade,Half-Elf,Wizard
Valendria,Elf,Warlock
Rickard Aegis,Half-Elf,Cleric
Tiernanar Darkhearth,Half-Elf,Sorcerer
Erevan Stormsreach,Halfling,Rogue
Arranis,Half-Elf,Cleric
Adlynn,Half-Elf,Ranger
Morgenstern,Elf,Ranger
Bbybjerg,Human,Cleric
Mithri,Half-Elf,Sorcerer
Arvind,Half-Elf,Wizard
JheelPhelan,Elf,wizard
Bridget ,Human,Cleric
BH ,Half-elf,Monk
Cyrus ,Human ,Fighter
Xypher,Catfolk,Ranger
A‘ph ,Human,Wizard
Mithri,Half-Elf,Sorcerer
Livith Bonnefoytte,Halfling,Rogue
Ativanope,Elf,Ranger
Catfolk,Elf,Ranger
Diana,Human,Monk
Carnivaldi,Half-Elf,Sorcerer
Aurelius,Human,Wizard
Renos Agurto Sitorus,Half-Elf,Ranger
Sofex,Human,Wizard
Blot,Tiger-Man
Ardent Venture,Human,Fighter
Xar,Human,Monk
Elaine Moonwhisper,Elf,Rogue
Human,Fighter
Triton,Human,Paladin
Human,Warrior
Bone,Dragonborn,Rogue
Fez,Half-Elf,Ranger
Crescendo Chamaranthe,Human,Bard
Precul Ipsem,Drow,Sorcerer
Golem,Dragonborn,Warrior
Chance,Half-Orc,Paladin
Beryl Stonebreaker,Dwarf,Fighter
Grumble Grimsfottir,Halfling,Rogue
Dalric,Human,Wizard
Mortharth of the Wildwood,Human,Ranger
Ferris,Half-Elf,Paladin
Zer'Chi,Githzerai,Monk
Page,Kenku,Warlock
Ander Brightfern,Aasimar,Cleric
Aukan,Dwarf,Fighter
Logan Gorestaff,Human,Fighter
Marcus Toussud,Human,Wizard
Deloro the Enchanter,Half-elf,Bard
Nameless,Warforged,Warlock
Kalice,Half-Orc,Fighter
Aukily Steelshadow,Elf,Monk/Fighter
Klaithyn,Half-elf,Rogue
Mudd,Half-orc,Fighter
Runar Goodhammer,Dwarf,Paladin
Kalgorr,Dragonborn,Warlock
Aldar,Human,Fighter
Asher Evenwood,Human,Sorcerer
Krablauch Stonebreaker,Dwarf,Rogue
Bartholomew Corville,Human,Wizard
Evaln,Elf,Wizard
Mira,Half-Elf,Bard
Bob with the flaming oil bombs,Gnome,Thief
Cosanne Bleeker,Human,Bard
Mirellia,Human,Druid
Bruz,Tiefling,Warlock
Huanchi Tameresh,Dragonborn,Sorcerer
Ben Lunesta,Human,Wizard
Lhurn the spell eater,Lizardfolk,HealEDUser
Xin,human,rogue
Kyrichgramer Brawnan,loxodon,barbarian
Symundi,goblin,sorceror
Shamm the spell eater,Half-Orc
Warforged,Warforged,Paladin
Mara Ravenwood,Human,Warlock
"Lucifer ""Luci"" Ondra",Human,Paladin
Bree Tealeaf",Halfling,Rogue
Samara,Half-Elf,Thief
Gillian Dreadwood,Human,Fighter
Gamal,Fire Genasi,Wizard
Pandora,Halfling,Bard
Godaleth,Human,Fighter
Jack Silvadar,Half-Elf,Sorcerer
Pandora,Halfling,Thief
Ienzo Zellik,Human,Wizard
Faurian Bloodmoon,Human,Bard
Sigmund,Human,Paladin
Griff Scifo,Human,Fighter
Sellos Tumiel,Half-elf,Rogue
Jurock,Gnome,Sorcerer
Krekk,Half-orc,Cleric
Colton Atherton,Human,Fighter
Sasheen Tiruani,Elf,Ranger
Deianira lightnguy,human,blood hunter
Hearth Pact,Human,Rogue
Amaterina,Half-orc,Assassin
Hearth Pact,Human,Fighter
Belathore Vessan,Elf,Paladin
Colton,Half-Elf,Fighter
Stuw,Gnome,Wizard
Todrick Brandywine,Halfling,Bard
Colton,Halfling,Thief
Ugddorf,Human,Fighter
Colton,Halfling,Ranger
Colton,Halfling,Thief
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Colton,Halfling,Ranger
Renvin Lasire,Human,Ranger
Valtor,Dwarf,Fighter
Kaiya,Human,Monk
Roland Weaver,Human,Wizard
Samira,Half-elf,Bard
HIllwyr Ironfist,Dwarf,Paladin
Aquarelle,Aasimar,Paladin
Qari,Drow,Warlock
Fiorello Longtooth,Half-Orc,Bard
Ug,Half-orc,Barbarian
Lumiirous,Human,Hunter
Fiorello Longtooth,Half-Orc,Barbarian
Maga Firedrift,Mountain Dwarf,Barbarian
Lem Goodbarrel,Halfling,Druid
Giles Bookkeeper,Half-glithe Elf,Paladin
Falafel Azul,High Elf,Warlock
Fionn Francster,Human,Cleric
Fionn Francster,Human,Cleric
Giles Bookkeeper,Half-glithe Elf,Paladin
Falafel Azul,High Elf,Warlock
Isaac Stormwind,Human,Fighter
Stormy,Tiefling,Wizard
Narcissa Caledor,Elf,Cleric
Marr,Catfolk,Rogue
Gorlo,Dragonborn,Cleric
Thistle,Dwarf,Cleric
Nessa Wooten,Halfling,Fighter
Shu the Lost,Orc,Lost One
Zandor,Half-Orc,Fighter
Murgos,Dwarf,Cleric
Songless,Half Elf,Bard
Barda Underbough,Halfling,Bard
Karja Stonevein,Dwarf,Druid
TinbrŽ,Mousefolk,Ranger
Caledor Valhen,Elf,Ranger
Songless,Half Elf,Bard
Caledor Valhen,Elf,Ranger
Songless,Half Elf,Bard
Amaru,Human,Rogue
Korakhammer,Halfling,Rogue
Songless,Half Elf,Bard
Songless,Half Elf,Bard
Songless,Half Elf,Bard
Songless,Half Elf,Bard
Ariel,human,wizard
Sora,elf,ranger
Karak,half-orc,barbarian
Sera,human,thief
Aria,human,cleric
Amaru,human,sorcerer
Tadashi,human,monk
Encumbrance,elf,bard
Zandath Brannhane,human,bard
Seven,Human,Rogue
Gideon,human,paladin
Dokun,half-orc,bard
Fenrir Frostbeard,Dwarf,Cleric
"Marip ""Dook"" Mileystrom",Half-orc,Bard
ZakÕlashh,Human,Fighter
Zalgracedor'ael'Faal,Elf,Ranger
Gurdwug the Gourmand,Dwarf,Fighter
Rattlebones,Gnome,Sorcerer
Goran Mahone,Half-Orc,Fighter
Zžkhwlaaey Sharptooth,Half-Orc,Fighter
Forfaux Flint,Human,Wizard
Burl Ivey,Half-Orc,Fighter
Hanks,Human,Fighter
Hank Slyhelm,Human,Fighter
Burl Ivey,Half-Orc,Fighter
Uthall,Dwarf,Fighter
Carter Peregrine,Elf,Ranger
Pip Littleton,Halfling,Rogue
Pip Littleton,Halfling,Rogue
Howard Oak,Human,Rogue
Ganthor Valhera,Human,Wizard
Hans Zoltan,Human,Wizard
Valerius Ambroise IV,Human,Fighter
Adolf Mao Stalin Hussein,Human,Wizard
AphSaxa,Human,Druid
Amaru,Human,Paladin
Chiyembe Amastacia,Half elf,Ranger
Aureth Siannodel,Half Elf,Bard
Celestine Darke,Human,Rogue
Qianingar,Human,Wizard
Ravil Tah,Human,Monk
Harding Verner,Human,Fighter
Caelynn Oak‡r,Human,Druid
Urin Woodroof,Half-Elf,Ranger
Ulli Wintermane,Elf,Ranger
Warhorn,Tiefling,Bladesinger 
Grunder Bloodbeard,Dwarf,Fighter
"Jocas ""The Nose"" Llewyn",Dwarf,Paladin
Bawdewyn Shimmerbizzle,Halfling,Ranger
Atumn,Firbolg,Druid
Dave,Human,Fighter
Kazrak,Kobold,Thief
Brynn,Half-Elf,Rogue
Dave,Human,Fighter
Udam,Human,Wizard
Heegol,Nemer,Barbarian
Caladon,Half-elf,Paladin
Dave,Human,Fighter
Caliban,Human,Wizard
Dave,Human,Thief
Caliban,Human,Wizard
Caliban,Human,Thief
Caliban,Human,Thief
Caliban,Human,Thief
Drizzt Gullygrlin,Dwarf,Ranger
Yarast,Half-Orc,Fighter
Merath Saergelfar,Grey Elf,Wizard
Yarast Saergelfar,Grey Elf,Wizard
Merath Saergelfar,Grey Elf,Fighter
Yarast Saergelfar ,Grey Elf ,Thief 
The great Yllalerg,Dhampir,Fighter
Larch,Catfolk,Dread Necromancer
Merath Saergelfar ,Grey Elf ,Fighter
Aoth,Human,Fighter
Phyryn,Catfolk,Rogue
Lovestealer,Elf,Wizard
Arkhdrauth Graysky,Human,Sorcerer
Kit,Half-Orc,Paladin
Bartholomew Trundlethump,Halfling,Warlock
Drexel,Human,Wizard
Brode Firestone,Dwarf,Cleric
Dooloco,Human,Druid
Bryn,Human,Oracle
Cobb,Tiefling,Sorcerer
Merrathwe,Human,Wizard
Fnatic,Half-Elf,Thief
Doyan the Lesser,Gnome,Wizard
Hoyt Thunderstone,Dwarf,Fighter
Mxyz Tzbot,Half-Orc,Wizard
Apocryphal,Doppel
Wyatt Wexler,Human,Fighter
Kathra Killaine,human,warlock
Sileena Blaize,tiefling,warlock
Shrecc,Half-Orc,Fighter
Nova Delamari,Elf,Druid
Dave,Human,Wizard
Sven Whitebeard,Dwarf,Cleric
Amafreyja Tanner,Human,Brawler
Cima-in-Detective-Nick,Human,Trickster Cleric
Ygerna,Drow,Fighter
Bruce,Human,Fighter
RAM,Human,Sorcerer
Wojtek Kougal,Human,Wizard
Ragnhild Craftsman,Human,Wizard
Shardra GmbH,Dwarf,Cleric
Bones,Human,Ranger
Gilpatrick Garthrite,Half-elf,Wizard
Tummak Lokaskyosh,Tummak Bombasticus,Tum-Killer
Figlor Helnofterit,Dwarf,Wizard
Qawasha,Human,Qerie Domain Warlock
Kole Telamari,Elf,Wizard
Oona Arithmane,Elf,Wizard
Coda,Human,Fighter
The Sacristan,Human,The Cleric
Virgil Van'stry andyn Oldranger,Human,Wizard
Thagana Vash�,Half Orc,Barbarian
Hesfix Arklighten,Gnome,Rogue
Haze Aligor,Human,Wizard
Bubble Bob,Halfling,Rogue
"Hiroshi ""The Monk"" Lin",Human,Monk
"Otto ""The Rat"" Nao-Tzu",Human,Monk
"Sasha ""The Eternal Rat"" Lin",Dragonborn,Monk
"Echo, the Eternal One",Human,Cleric
Furgus Razorbeard,Dwarf,Bard
Isabeau LeRoux,Human,Monk
"Despuir, the Eternal One",Elf,Wizard
Aesh,Elf,Wizard
Feal,Human,Paladin
Myrrthaiys Acapulis,Drow,Warlock
Anot,Human,Cleric
Rathkar Gellath
Cleveland,Human,Cleric
Flock,Slime,Cleric
Auk'rea,Aarakocra,Rogue
Rhona,Tiefling,Sorcerer
Merrik Hilltopple,Halfling,Paladin
Duran Duran,Dwarf,Bard
Rhona,Tiefling,Paladin
Brina Flinthollow,Dwarf,Wizard
Dim,Gnoll,Psychic Warrior
Sanguineus,Tiefling,Tin Man
Savorito,Human,Wizard
Nelaeryn Starwhisper,Elf,Wizard
Malais al-Sissiri,Elf,Monk
Sariel,Tiefling,Ranger
Ashlinn,Halfling,Ranger
Leliel,Elf,Paladin
Arby,Half-Elf,Fighter
Rose McLaha,Half-Elf,Cleric
Gratia Coalspark,High-Elf,Fighter
Vivek,Orc,Barbarian
Kibale Gola,Dragonborn,Barbarian
Bluebeard,Dwarf,Ranger
Caligasia,Human,Warlock
Zephyr,Drow,Rogue
Fang,Human,Fighter
Maria,Half-Sealed,Warlock
Vivian Fanafir,Teifling,Sorcerer
Burlok the Bashful,Jester,Mercenary
Hans,Human,Cleric
Gum,Gumet,Rogue
Tessa,Human,Fighter
Orba,Barbarian,Eldritch Knight
MŸgon,Goliath,Fighter
Orba,Barbarian,Eldritch Knight
Oliu,Human,Bard
Gukumon,Human,Barbarian
Yobab,Half-Orc,Barbarian
Iby,Human,Wizard
Carver,Darquean,Cleric
ICavalbuffy,Icthlanger,Blood Hunter
Imri Amri,Human,Rogue
Izonog,Dwarf,Fighter
Muriel Hammerhand,Dwarf,Cleric
Song of Bronze,Aasamir,Bard
Onfmann MacGregor,Aasimar,Bard
Foxx,Half-elf,Rogue
Astrid,Human,Warlock
Kiirdal Drow,Human,Wizard
Bael,Human,Ranger
Morsk,Dwarf,Fighter
Wreade,Dwarf,Warrior
Jancey,Halfling,Half-elf,Rogue
Krieg,Half-orc,Fighter
Flip,Human,Rogue
Krieg,Half-orc,Fighter
Princess Amara of the Wastes,Half Elf,Paladin
Dara Tenn‘,Human,Wizard
Cam'racne,High elf,Wizard
Huffington Broadfoot,Halfling,Bard
Tessa Ravencrest,Human,Bard
Polymath,Human,Psion
Jamnugget,Illithid,Enchanter
Guards,Orc,healer
Yularen,Hobgoblin,mage
Skog,Half orc,thief
Grung,Orc,thief
Makos,Tiefling,Thief
Hood,Half-elf,Thief
Kellis,Human,Ranger
Packin Longk***,Half-Orc,Fighter
Minsk,Half-Orc,Barbarian
Grik,Orc,Cleric
Hiroshima,Human,Sorcerer
Rama,Human,Fighter
Rashid,Human,Wizard
Marcus,Human,Fighter/Rogue
Husk,Kenku,Rogue
Mabitha,Human,Bard
Duran,Warforged,Swordmage
Wira Emerson,Wood Elf,Wizard
Barry,Human,Wizard
Goomagomp,Gnome,Wizard
Aleria,Human,Ranger
Ferulian,Human,Fighter
Fang,Human,Wizard
Parb Proudfoot,Halfling,Fighter
Grougon,Orc,Wizard
Voltaire,Human,Sorcerer
Grave Imprisonment,Human,Barbarian
Embaldi the Clerical,Human,Mage
Aramril,elf,mar
Thanatos,Human,Spiritualist
Ganthor,Human,Wizard
Aramil,elf,ranger
N'lor

Grundusk Giantsbane,Human,Paladin
"Althaea ""Thea"" Kidimyr",Half-Orc,Fighter
"Althazar ""Thea"" Esau",Human,Druid
Korizawa Yasutake,Human,Wizard
Hashib,Goblin,Hunter Ranger
Iogara,Half-Orc,Fighter
Iroh Odrynta,Half-Ogre,Sorcerer
Heinan,Elf,Paladin
Brigard,Human,Fighter
Ferago,Halfling,Rogue
Mera Frostmane,Dragonborn,Barbarian
Fizz,Halfling,Sorcerer
Reeve,Elf,Warlock
Sheremess,Human,Cleric
Daechir,Gnome,Oracle
Daechir,Gnome,Oracle
Shemeticus Bohminglass,Human,Swordmage
Shemeticus Bohminglass,Human,Wizard
Dominus Jutttar,Human,Fighter
Borlin Jawbreaker,Dwarf,Paladin
Mechrat,Changeling,Rogue
Sorrid,Half-Orc,Barbarian
Aquanica,Elf,Druid
Aeon,Elf,Ranger
Aquanica,Elf,Ranger
Romar-Kits-Ramner,Human,Thief
Logan,Human,Thief
Romain,Human,Fighter
Talon,Half-Elf,Thief
Zelazaron,Shifter,Bard
Applonia,Tiefling,Ranger
Applonia,Tiefling,Rouge
Applonia,Tiefling,Ranger
Applonia,Tiefling,Ranger
Garmr Harbormaster,Dwarf,Barbarian
Thrall Thornwind,Human,Paladin
Applonia,Tiefling,Ranger
Applonia,Tiefling,Ranger
Rhyisj,Wild Elf,Cleric
Rhyisj,Wild Elf,Cleric
Rahvin Kennings,Human,Necromancer
Applonia university,Tiefling,Rogue
Applonia,Tiefling,Ranger
Applonia university ,Tiefling
Finnen Dragonborn,Human,Ranger
KÕDhaldir,Half-Dryad,Druid
Garett‘ the Wanderer,Human,Warrior
Nim,Human,Wizard
Puck,Rind of house,Ranger
Ardour,Wood Elf,Monk
Finch,Human,Fighter
Inkling Knillwick,Gnome,Druid
Schpack,Warforged,Fighter
Regan Hart,Human,Warlock
Onacia,Half-Elf,Druid
Kurgen Berghert,Half-Orc,Wizard
Yngvarr ,Duergar,Barbarian 
Tola ,Tiefling,Barbarian
Sol Algar,Half-Elf,Rogue
Hurdhur Stoutpike,dwarf (mountain),paladin
Mitch,Human,Battlemaster
Tordek StrongSaxon,Dwarf,Bard
Vormunde,Dragon,Monk
Strongbelly,Human,Barbarian
Virgil,Human,Rogue
Strongbelly,Human,Barbarian
Asmagnar Lutward,dwarf (mountain),ranger
Gruk,Half-Orc,Barbarian
Gruk,Half-Orc,Barbarian
Reep-a-Leek,Lizardfolk,Rogue
Scarlet Hemlock,Human,Wizard
Vee,Changeling,Bard
"Aeneas, son of Iwo Jima",Halfling,Wilder
Fish,Goblin,Fighter
Fish,Goblin,Fighter
Ello,Half-Elf,Rogue
Albany,Wood Elf,Monk
Fronk,Human,Fighter
Miron,Half-Elf,Fighter
Fronk,Human,Fighter
Fronk,Human,Fighter
Arnthor,Human,Fighter
Brynn,Half-Elf,Fighter
Delphinium,Bugbear,Fighter
Brynn,Half-Elf,Fighter
Nim,Half-Elf,Fighter
Gron,Half-Orc,Fighter
Arnthor,Human,Fighter
Dezmiatra
Finn,Human,Rogue
Xypher,Catfolk,Monk
Frondypence,Elf,Wizard
Khurz,Half-Orc,Barbarian
Xathra,human,sorcerer
Boomer,Human,Coastal Druid
Wren,Half-Orc,Druid
Xaikon,Tiefling,Ranger
Kri,Tabaxi,Fighter
Aerilyn,Dragonborn,Paladin
Pavel,Human,Monk
Torq,half-orc,fighter
Auriel Beoluve,Human,Sorcerer
Shaniqua Aussir,Human,Bard
Rerilla M'ntrag,Dragonborn,Paladin
Zoe,human,ranger
Jakor the Knife,Human,Thief
Bae in Teatro,Tiefling ,Paladin 
Sidel Ta'alus,Human,Sorcerer
Lorelei,Human,Rogue
Aelar Anastasia,Elf,Wizard.
Sorel Loerby,Half-elf,Ranger
Beshil-Springfield,Half-Elf,Wizard
Vae-Guthijr the Bold,Gnome,Ranger
Jaamen the Deceiver,Human,Cleric
Kareetkh,Half-Orc,Cleric
Ahme,Genasi,Warlock
Pfbsworth The One Who Knelt Down Before Me,Human,Monk
Chaim Grunblatt,human,sorcerer
Tsuki Hikari,Human,Wizard
Tsuki Hikari,Human,Warlock
Nichelle Mann,Human,Fighter
Mawl,Kobold,Ranger
Haki Ormas,Human,Fighter
Kamagumi Tako,Human,Fighter
Donna,Wilden,Archer
Sora,Genasi,Druid
Iseph,Samsaran,Ranger
Vazri,Tiefling,Monk
R'mstblad,Orc,Fighter
S'priest Gvalsen,Elf,Wizard
Alva,Human,Fighter
Tambuoke,Hengeyokai,Cleric
Islitgro,F
Wyndrega Greenbeard,Dwarf,Cleric
Shrilloc the Mountain,Human,Rogue
Breena Cappella,Human,Paladin
Wyndfyll,Human,Ranger
Wyndfyll,Human,Ranger
Wyndfyll,Human,Ranger
Shrilloc the Mountain,Human,Ranger
Shrilloc the Mountain,Human,Ranger
Shrilloc the Mountain,Human,Ranger
Shrilloc the Mountain,Human,Ranger
Shrilloc the Mountain,Human,Ranger
Shrilloc the Mountain,Human,Ranger
Wyndfyll,Human,Ranger
Xin,human,paladin
Canton,Human,Paladin
John Doe.",halfling,wizard
Gideon,Human,Rogue
Khalash,Human,Shaman
Tal'Shal,Human,Thief
Edrid Hallsbane,Human,Wizard
Hearthpiece,Dwarf,Cleric
Hri'alriel,Elf,Cleric
Tor'Kko,Human,Monk
Kadra,Human,Wizard
Sara Sonsmasher,Human,Paladin
MASH ,Dragonborn,Ranger
Jakka Nailo,Dwarf,Fighter
Penelope Greymoore,Elf,Wizard
Rajcha the Bold,Gnome,Cavalier
Rap Lightning,Human,Fighter
Amber Redmara,Dwarf,Cleric
Maximus,Human,Fighter
Titus Mason,Human,Cleric
Anna Sunstander,Half elf,Bard
Alexione Zarassina,Human,Wizard
Reep-a-Cheep,Kenku,Rogue
Krunk,Half-Orc,Paladin
Morro Folkvangr,Tiefling,Bard
Thormund Moonwhisper,Elf,Ranger
Jayda Windcrest,Human,Ranger
Crag-Log,Half-Orc,Barbarian
Hobbs far-right,Mountain-elf,Ranger
Socks Proboscis Gelato,Half-elf,Paladin
Squee Gyu,Mountain dwarf,Barbarian
Sun Yat-sen
Dagstorp,Human,Wizard
Hazred,Human,Barbarian
Thokk,Half-orc,Barbarian
Dagstorp,Human,Wizard
Hazred,Human,Barbarian
Nagash,Elf,Rogue
Ghoran,Half-Orc,Cleric
Asher,Human,Rogue
Malkyn,Elf,Wizard
Wynn Butterworth,Human,Ranger
Darius Hawke,Human,Wizard
Veshian Hawke,Human,Warlock
Fenthwick Fizzlebang,Gnome,Artificer
Holly Woolwich,Human,Ranger
Hummingbird,Human,Barbarian
Audrien the Huntress,Human,Paladin
Derrick Jin,Human,Wizard
Shaniqua Farimosa,Elf,Bard
Dano,Human,Rogue
Jin Fellthorne,Elf,Fighter
Rinn Peyten,Elf,Wizard
Jinkies,"Shifter, Wild Divine Totem",Cleric
Sin Jax,Human,Warlock
Jingles,Kenku,Ranger
Jin Fellthorne,Elf,Fighter
Spine,Human,Ranger
Jin Fellthorne,Elf,Fighter
Mochi,Human,Barbarian
Ygern,Human,Bard
Eio Hoshida,Half-Orc,Fighter
Felonius Leo,Half Elf,Warlock
Bardello,Tiefling,Paladin
Bardello,Thri-kreen,Fighter
Lareon,Halfling,Rogue
Sterling Leith,Halfling,Warlock
Anton Tileshaft,Halfling,Rogue
Maulk-Rawlk,half-orc,Barbarian
Magpie,Human,Wizard
Dark Star,Tiefling,Monk
Feldspar Brannfjell,Dwarf,Paladin
Bronwin Birla,Halfling,Bard
Onnahi,Halfling,Rogue
Bronwin Birla,Halfling,Bard
Onnahi,Halfling,Rogue
Bronwin Birla,Halfling,Bard
Bronwin Birla,Halfling,Bard
Drag'hul,Dwarf,Cleric
Strix,Half-Orc,Rogue
Drag'har Bitterblink,Halfling,Rogue
Brynn Renwood,Half-elf,Wizard
Nyhmhrry Delmirev,Dragonborn,Sorcerer
Tifa Ti'kalla,Tiefling,Warlock
Nyx,Warforged,Warlock
Brynn Renwoodham,Half-elf,Warlock
Fulthan Kreshakkal,Dwarf,Rogue
Drago,Half-Orc,Fighter
Aesh,Elf,Wizard
Teldr Swordfist,Elf,Wizard
Vex,Elf,Cleric
Merikk,Half-Elf,Sorcerer
Oakenskull,Half-dragon,Fighter
Nerim Undiel,Elf,Ranger
Rugface the Glamourful,Half-Elf,Paladin
Jade,Human,Fighter
Cricket,Elf,Thief
Rooster,Half-orc,Barbarian
Bert,Gnome,Wizard
Tadar,Human,Ranger
Gar,Half-orc,Fighter
To'ilick,Gnome,Warlock
Zhmokk,Half-orc,Barbarian
Sora,Dwarf,Barbarian
Anotious,Kobold,Cleric
Tinker,Warforged,Artificer
Tinker,Warforged,Artificer
Eldromanth,Elf,Artificer
Myst,Tiefling,Rogue
Evaleth,Elf,Artificer
Thrandhuil Sthrom,Elf,Fighter
Kurtly Whatsitsboningon,Halfling,Bard
"William ""Dubs"" Walker",Human,Barbarian
Thelyke ""Smalls"" Belmont",Human,Ranger
Willwagonsnatch,Tabaxi,Rogue
Risorial,Elf,Rogue
TessŽle Woodweevil,Half-Elf,Wizard
Atmariok,Lizardfolk,Ranger
Esveth,Elf,Druid
Riptide of the
Goblin,Human,Monk
Wren,Elf,Rogue
Silys,Half elf,Ranger
Nano Richards,Human,Fighter
Jango Booga,Halfling,Thief
Brynn,Half-elf,Paladin
Kikori Hanabishi,Human,Fighter
Alithanar,Wood Elf,Ardent
Arland Yardne,Human,Rogue
Bellwick Firebrand,Dwarf,Witch
Senn Treeshield,Human,Cleric
Brynn,Half-elf,Ranger
Odo Levesque,Human,Warlock
Teldr Swordheart,Elf,Wizard
Fionund Morngoldt,Dwarf,Cleric
Sir Omo,Vampire,Ranger
DAGAL,Human,Wizard
Tierney Mountain,Human,Cleric
Hawthorn,Human,Warlock
JARVIS,Human,Wizard
Corporal Aedrian Talon,Tiefling,Paladin
Kurosh Q'eda,Human,Cleric
Ankita Amastacia,Half-vampire,Berserker
Aurelia Brightfeather,halfling,fighter
Kris Stonehammer,Dwarf,Cleric
Jace,Human,Wizard
Tierney Mountain,Human,Cleric
Hawthorn,Human,Warlock
Jade,Human,Ranger
Fargrim Darrak,Half-Orc,Barbarian
Boras Stonehammer,Dwarf,Fighter
Cora Skye,Halfling,Rogue
Kris Stonehammer,Dwarf,Fighter
Aurelia Brightfeather,halfling,fighter
Aurelia Brightfeather,halfling,fighter
Aurelia Brightfeather,halfling,fighter
Hawthorn,Human,Wizard
Aurelia Brightfeather,halfling,fighter
Cora Skye,Halfling,Rogue
Aurelia Brightfeather,halfling,fighter
Cora Skye,Halfling,Rogue
Aurelia Brightfeather,halfling,fighter
Aurelia Brightfeather,halfling,fighter
Aurelia Brightfeather,halfling,fighter
Kobone Talon,Human,Knight
Kamou,Human,Paladin
Basil,Half-Elf,Rogue
Fenris,Human,Ranger
Jad,Elf,Fighter
Galith Vrothaeris,Human,Cleric
Maia,Half elf,Fighter
Zauriel Otellimaeus,Half Elf,Bard
Vissak the Beguiling,Human,Rogue
Lawgiver Puddle,Tortle,Cleric
Gollum,Gnome,Oracle
Garim Gamwort,halfling,bard
Lurk Helmsman,human,barbarian
Ardent Venture,Human,Wizard
Eltharion,Half elf,Fighter
Elthyrr,Elf,Fighter
Unit Alphus,Warforged,Monk
Spo Dog,human,bard
Hu-man,human,fighter
Cigfran,Human,Druid
Unit Alphus,Warforged,Monk
Borgo,Human,Fighter
Unit Alphus,Warforged,Monk
Spo Dog,human,bard
Hulan,Elf,Fighter
Unit Alphus,Warforged,Monk
Borgo,Human,Fighter
Unit Alphus,Warforged,Monk
Hulan,Elf,Fighter
Unit Alphus,Warforged,Monk
Spo Dog,human,bard
Lorelai,Half-Fiend,Assassin
Bukbuk,Human,Fighter
Sir Tyrus,Human,Rogue/Ninja
Aurum,Human,Cleric
Vell,Human,Fighter
Syrea Rei'gatz,Doppelganger,Wizard
Fiona,Human,Paladin
Girlit,Orc,Fighter
Fiona,Human,Paladin
Kaavi,Half-Elf,Bard
D'Solo,Human,Rogue
Tharivol Liadon,Elf,Ranger
Tharivol Liadon,Elf,Ranger
Abery Gin,Human,Paladin
Noorah,Halfling,Warrior
Zahav,Human,Monk
Kairon,Tiefling,Dru
Finn,Human,Fighter
Kathra,Human,Assassin
Schpack,Pixie,Rogue
Ratling,Ratling,Sorcerer
Ratling,Ratling,Rogue
Ratling,Ratling,Rogue
Redeemer,Minotaur,Monk
Tom,Human,Bard
Ygritte,half-orc,Barbarian
Rook,Half-Orc,Monk
Throkk,Half-orc,Fighter
Cerefindel,half-elf,Bard
Anya,Half-elf,Wizard
Delg,kitsune,astral champion
Ezahr,Human,Sorcerer
Nyx,Tiefling,Rogue
Astra,Human,Druid
Rakdfal,Half-orc,Fighter
Jolana Sismone,Human,Fighter
Nyx,Tiefling,Rogue
Amethea Cucumber,Tiefling,Wizard
Mozear McFlack,Human,Healer
Surkiel Benjamin,Water Elf,Monk
Theophania Kaloghen,Fire Genasi,Artificer
Dr. Benjamin,Human,Artificer
Tecla Moldovite,Half-elf,Bard
Amryyll,Half-elf,Druid
Cornelius Benillust,Human,Wizard
Alicia Pena,Dwarf,Fighter
Cornelius Benillust,Human,Wizard
Lydia Cornwell,Half-Elf,Rogue
Fiammetta Faust,Human,Ranger
David,human,warlock
Arelia,Elf,Ranger
Ydoga,Half-Orc,Fighter
Fronan,Human,ranger
David Bowie,Human,Bard
Humilitas,Tiefling,Bard
Humilitas,Tiefling,Bard
Humilitas,Tiefling,Bard
Humilitas,Tiefling,Bard
Humilitas,Tiefling,Bard
Humilitas,Tiefling,Bard
Humilitas,Tiefling,Bard
Humilitas,Tiefling,Bard
Palmer,Human,Wizard
Astra,Human,Ranger
Caelynn,Half-elf,Bard
Radagast,Human,Paladin
"Barry ""Baz"" Spice",Half-giant,Barbarian
Kova,Half-orc,Cleric
Greatest,Goliath,Barbarian
Puck,Human,Druid
"Barry ""Spice"" Spice",Half-giant,Barbarian
Alijah,Human,Ranger
Taranir,Half elf,Rogue
Lerris Malys,Human,Sorcerer
Kathra Torunn,Dwarf,Bard
Jemri Rainer,Human,Fighter
Teggin aur'Zinpurge,Dwarf,Cleric
Jakor Forebears,Half-orc,Paladin
Mondo Sinto,Dwarf,Bard
Varis Hornraven,Half-elf,Sorcerer
Morgulini Abshmal,Dwarf,Fighter 
Mondo Sinto,Dwarf,Fighter
Teggin aur'Zinpurge,Dwarf,Cleric
Jemri Rainer,Human,Fighter
Teggin aur'Zinpurge,Dwarf,Cleric
Jemri Rainer,Human,Fighter
Teggin aur'Zinpurge,Dwarf,Cleric
Jemri Rainer,Human,Fighter
Jemri Rainer,Human,Fighter
Jemri Rainer,Human,Fighter
Sarabelle,Elf,Warlock
Ardent Venture,Human,Necromancer
Aristotle Ichorian,Human,Theif
Mirayfolk,Dragonborn,Paladin
Ibrahim Inke Ikuku,Human,Fighter
JACOB ELLIOTT,Half-Drow,Cleric
JACOB ELLIOTT,Half-Drow,Cleric
GUY,Half-elf,Rogue
GUY,Half-elf,Rogue
GUY,Half-elf,Rogue
GUY,Half-elf,Rogue
GUY,Half-elf,Rogue
GUY,Half-elf,Rogue
Mallorca Ironfist,Dwarf,Paladin
"Morarall ""Madame"" Mora",Half-Elf,Rouge Bard
Brynn,Half-elf,Paladin
"Fionna beheld the spine of a winged Andry Bearbow, undisturbed for 1,000 years",Tiefling,Ranger/Bard
Smynogg,Half-fiend,Wizard
Thud,Warforged,Barbarian
Haemir,Half-elf,Sorcerer
Creepy,Half-Orc,Barbarian
Morgarren,Human,Wizard
Sweepstakes,Human,Ranger
Valor,Human,Wizard
Sagard,Human,Fighter
Honor Redeemer,Human,Paladin
Roheh,Human,Rogue
Zillahyril,Half-elf,Bard
Zirk,Dragonborn,Wizard
Ebran Thane,Human,Rogue
"Wilhelm, Defender of Mores"
Exeter,Elf,Ranger
Loken,Human,Wizard
Lara Hudson,Halfling,Sorcerer
Nim,Half-elf,Rogue
Reykera,Tabaxi,Monk
Kavros,Dragonborn,Fighter
Zirnitra,human,sorcerer
Fifi Yammath,Human,Bard
Valanthe Lorescaster,Elf,Rogue
Praetoria,Human,Cleric
Lazarus,Human,Fighter
Ren Shyheel,Human,Cleric
Mister Shyheel,Human,Fighter
Mister Shyheel,Human,Fighter
Aspen,Elf,Mage
Tink,Elf,Thief
Dench,Half-orc,Fighter
Molly,Human,Wizard
Tinker,Warforged,Clockwork Knight
Petru Cozma,Half-Orc,Mage
Drullet Cozma,Half-Orc,Fighter
Pyrillia,ogre,druid
Horchata Absianson,Half-Vampire,Rogue
Nymeria,ogre,warlock
Morwen,ogre,warlock
Grundle,Half-Or
Warhorn,Human,Fighter
Rannoch Ramstead,Half-orc,Bard
Harding Verner,Half-Elf,Paladin
Trenos Tallfellow,half-elf,Bard
Morwenna Bushblood,Dwarf,Cleric
Tyllos,High Elf,Wizard
Rogan Mithralhall,Half Orc,Fighter
Ullobash Doomseeker,half-orc,Paladin
Nylan,Half-Orc,Fighter
Zahav,Zealot,Cleric
Tenebarius,Human,Warlock
Arkhan,Half-orc,Cleric
Tilo Tlin,Half-Elf,Bard
Lunia,Half-Elf,Rogue
Zethron,Half-Orc,Wizard
Shrane,Elf,Ranger
Valinon,Elf,Rogue
Khenemet,Half-Elf,Paladin
Pbbits,Gnome,Warlock
Tinker,Warforged,Bard
Dren Burrows,Half-Elf,Rogue
Nubelin,Elf,Monk
Pogranax,Half-Orc,Wizard
Pooka,Halfling,Barbarian
Sheck,Human,Wizard
Celandine,Human,Fighter
Fjell Acornsson,Wood Elf,Ranger
Fjell Thornblood,Human,Fighter
Gamal,Human,Wizard
Owen ,Half-elf,Cleric 
Sunshine,Human,Rogue
Thamior / ZigZag Zig-zag,Human,Wizard
Bandersnatch,Dragonborn,Warlock
Ilyrien Merlen,Elf,Cleric
Bayel Hillgirth,Halfling,Bard
Legitmod the Hand of Fate,Human,Fighter
Mialeex N'raq,Elf,bard
Xanadia 'Irias' Miaoudaute,High elf,Paladin
Xa'u Ur,Aarakocra,Ranger
Xanandaariat,Tiefling,Bard
Ellian Thistledown,Human,Paladin
Nemia,Halfling,Bard
Melody,Tiefling,Bard
Melody,Tiefling,Bard
Ace Verde III,Human,Paladin
Avalynn Buxte,Half-Elf,Sorcerer
Leia Maalir,Human,Wood elf,Druid
Henry Barlow,Halfling,Barbarian
Kilard Dovenayan,Human,Fighter
Kira Langley,Half-Elf,rogue
Kirge Underbough,Halfling,Monk
Seven Silk,Tabaxi,Rogue
Vonda Marivaldi,Half-Elf,Bard
Orion Yavie,Human,Paladin
Felix Menderson,Human,Cleric
Tihrenel,Elf,Wizard
Kazor Dragonslayer,Human,Barbarian
Hershal Bhone,Human,Ranger
Harren Hull,Human,Fighter
Samaur Vulkar,Human,Brawler
Samue,Human,Wizard
Mendeton Wolfsbane,Dwarf,Paladin
Samue,Human,Wizard
Nimue,Human,Druid
Hakon,Human,Barbarian
Buz,Human,Wizard
Bankot,Half-orc,Barbarian
Bankowyn,Halfling,Bard
Dook,Half-Orc,Monk
Datatt,Human,Sorcerer
Garet,Half-Orc,Barbarian
Brynn,Half-orc,Barbarian
Celeste Starberry,Human,Cleric
Astrid Hunterson,Human,Crusader
Toome,Aarakocra,Monk
Duncan,Human,Rogue
Mikry Kay,Human,Wizard
Mikro ,Human,Monk
SirRobin,Human,Rogue
Orelka Moondown,Half-Elf,Paladin
Bridget Valter,Human,Warrior
Ragkaja ,Half-Orc,Cleric
Aramril,Human,Paladin
Sansorial Sash,Half-Elf,Druid
Lizzie,Drow,Rogue
Jade,Half-Orc,Barbarian
Cora Goodbarell,Hobbit,Paladin
Hagron Ashpinn,High Elf,Wizard
Ragkaja ,Half-Orc,Barbarian
Ishmael Von Helmholtz,Human,Warlock
Kurtly Mists,Human,Rogue
Grok,Half-orc,Barbarian
Thog,Half-goliath,Barbarian
Zohara,Tiefling,Warlock
Foris,Human,Ranger
"Emeric, Lord Argent",Human,Fighter
 ""William the Third"" Kenneth",Human,Warlock
Heinrich von Grauf-Weinbrandt,Human,Fighter
Axel ÒScipioÓ Flaminiferium Stonefist,Dwarf,Monk
Rai,Human,Ranger
Tundrok,Human,Fighter
Vicgretor Stakhtien,Half-Elf,Bard
Velona,Half-Elf,Sorcerer
Fabulor the Bold,Gnome,Wizard
Taren,Half-Elf,Barbarian
Emrak,Human,Paladin
Brigard,Human,Fighter
Fonk,Human,Fighter
Andros,Human,Fighter
Mu Lung,Half-Orc,Monk
Luca Serria,Aasimar,Paladin
AuRon,Human,Ranger
Ailrich Edmundson,Halfling,Cleric
Helene Mytraits,Human,Fighter
DYLAN DESOTO,Half-elf,Warlock
GROK'S HAUNT,Half-Goliath,Barbarian
JASPER OLVIN'T KILL,Half-elf,Warlock
THE WIZARD,Warforged,Fighter
TALI,Tiefling,Bard
GUY Zolla,Half-Orc,Barbarian
MICHAEL OLVER,Half-elf,Fighter
MICHAEL OLVER,Half-Goliath,Barbarian
MICHAEL OLVER,Half-Goliath,Barbarian
TALI,Tiefling,bard
MICHAEL OLVER,Half-goliath,barbarian
NANCY H'Shayne,Human,Ranger
SECOP,Human,Wizard
JUDA,Human,Fighter
SECOP,Human,Wizard
Rise,Human,Wizard
STYTH,Half-Orc,Monk
Grendilin,Half-Elf,Rogue
Aldric,Human,Cleric
Ovelia,Half-Elf,Rogue
Ygerna,Half-Elf,Ranger
Luvernia Butternose,Dwarf,Wizard
Malkyn Sharptooth,half-elf,bard
Fergach,Half-Orc,Druid
Vivian Blackhart the vi,halfling,assassin
Tarn,Human,Barbarian
Nim,Half-Elf,Ranger
Hulan,Human,Monk
Lane,Human,Fighter
Zervoul the Lesser,Human,Wizard
Grulka,Half-orc,Ranger
Curtis Galanodel,Elf,Paladin
Taranath,Half-Elf,Wizard
Taranath,Half-Elf,Ranger
Vilthala Blackwater,Half-Elf,Cleric
Adranviel,Elf,Warlock
Elmal,Elf,Fighter
Xyheld,Human,Rogue
Fiji,Human,Bard
Konkar Meridee,Drow,Rogue
Xandra,Forest Gnome,Cleric
Magho,Half-Orc,Barbarian
Li Flint,Half-Elf,Warlock
Kurnous,Human,Druid
Puck,Dwarf,Fighter
Xyrora,Catfolk,Sorcerer
Spiranus Vacivus,Dragonborn,Sorcerer
Arizma Thelmin,half-orc,Paladin
Maribolyn of the House of Ballad,Half-elf,Bard
Creed,Tiefling,Bard
Davious Blackstorm,Human,Barbarian
Lilith,half-elf,warlock
Hefor,Human,Fighter
Magho,Half-Orc,Barbarian
Ophelia,Human,Wizard
Tarilide,Rose Knight,Rose Knight
Bodle,Human,Druid
Kurik,Panther
Thorn,Halfling,Thorn
Bodger,Halfling,Thorn
Kaijima,Human,Fighter
Malika,Human,Fighter
Tuscar Atta'ampaho,D
M'hmm,Orc-human-folk,Fighter
Xavier Halverick,Human,Rogue 
"Choke-Hold ""Chuck"" Reiley the Mulmaster Sea-Snake!",human,Barbarian
Alvin Harken,Human,Fighter
Ace Tharlemund,Human,Fighter
Tikka njsk,Halfling,Rogue
Samurda,Lizardfolk,Cleric
Gvard,Orc,Fighter
Gvard,Orc,Fighter
Waywocket Nackle,Gnome,Rogue
Elda Mighty,Human,Fighter
Waywocket Nackle,Gnome,Fighter
Gvardmak Bluebrow,Dwarf,Bard
Vandrol Shyr ,Drow ,Rogue
Waywocket Nackle,Gnome,Fighter
Alvin Doornail,Half-Elf,Thief
Josip Broz Tito,Changeling,Rogue
Gneron ,Human,Fighter
Bitti,human,thief
Moszar,Human,Wizard
Zdrava the Magnificent,Human,Sorcerer
Axlanter,Human,Fighter
Ralmyn Greenbottle,Halfling,Ranger
Axlanter,Human,Fighter
Rolovious Firenaster,Elf,Wizard
Tenerallin Cerellian,Dragonborn,Paladin
Hande Maolor,human,wizard
Stef,human,rogue
Mörkwidwen,dwarf, necromancer
Einar,Aasimar,Cleric
Mörkwidwen,dwarf, necromancer
Isaac Folkor,human,sorcerer
Mörkwidwen,dwarf, necromancer
Wenn Hauser,dwarf,cleric
Harkum Kennings,Dwarf,Wizard
Evaleth,Human,Cleric
Bruenor Redoran,dwarf,cleric
Elenchis,Human,Wizard
Stiggo,Human,Thief
Dolly Wren,half-elf,thief
Ballastar Stalkingwolf,elf,wizard
Dzimm,half-orc,cleric
Myrrthaiys Arelasian,Wood Elf,Ranger
Solveig Greywolf,Human,Barbarian
Sora Greenwolf,Gnome,Wizard
Rylver,Half-Elf,Rogue
Arnthor,Human,Paladin
Boorab Widepad M'ginty Thorntussle,halfling,wizard
Rudy Kulos,Human,Fighter
NurnieSmelt Brega Thar,Half-orc,Ranger
"Moranna ""Amor""",Tiefling,Warlock
Shayde Alton,Human,Fighter
Pangar,Half-Orc,Monk
Althea Flamebearer,Half-elf,Bard
Hulan,Human,Fighter
Khalodin Zytheum,Gnome,Wizard
Sutthi ,Tiefling,Rogue
Zook Zurhaar,Human,Ranger
Pudgei Ghoulbane,Goblin,Warlock
Rahik Eastwatch,Aasimar,Cleric
Rahim Eastwatch,Human,Cleric
Xenorath Constantine Darkmoon,High elf ,Rogue 
Addax Wood2/Half-elf,Druid
Leona,Human,Monk
Nixie Chaza,Dragonborn,Paladin
Felicity Cloverweave,Air Genasi,Monk
Mikael Boosh,Half-Orc,Barbarian
Estos,Elf,Ranger
El Camino de Santiago,Human,Warlock
Foostus Dinar,Human,Wizard
Abb forfend,Halfling,Fighter
Hoppus,Half-Elf,Bard
Hoppus,Half-Elf,Barbarian
Feyjak,Tiefling,Ranger
Hoppus,Half-Elf,Wizard
Barnabus Ulysses Wheatrow,Human,Wizard
Hoppus,Half-Elf,Ranger
Hoppus,Half-Elf,Barbarian
Hoppus,Half-Elf,Warlock
Thorny Bloodaxe,Hill Dwarf,Cleric
Iron Head,Dwarf,Cleric
Thorny Bloodaxe,Hill Dwarf,Cleric
Warhorn,Human,Barbarian
Ikou,Human,Barbarian
Na'helar,Half-Elf,Druid
Sirikus Giltharus Willowbend,Elf,Rogue
Emeth,Tiefling,Wizard
Kourne Goldenbeard,man,barbarian
Loren Owen,Human,Ranger
Fonkin Fnipper,gnome,bard
Menekhanon,Half-Elf,Bard
Azumel,Half-Elf,Ranger
Wynnkin Zonsno,Gnome,Warlock
Fellie,Warforged,Wizard
Mos Ecan,halfling,cleric
Fellan,wood elf,druid
Korendil Xiloscient,Elf,Wizard
Jandar Helmsman,Human,Ranger
Valor,Firbolg,Druid
Valor,Firbolg,Druid
Sebastian Hedgewise,Human,Ranger
Kaijeras,Human,Monk
Morarall,Changeling,Bard
Iorciah,Drow ,Rogue-
Teeson Longfellow,Halfling,Bard
Nyamh's son,Elf,Druid
Gully Forgeclang,Dwarf,Warrior
Wren Bloodaxe,Dwarf,Warrior
Morskoy Hardronglk,Dwarf,Wizard
Kazdan,Human,Barbarian
Staniv,Half-Elf,Warlock
Celedor Stonesun,Dwarf,Fighter
Kriek,Aarakocra,Cleric
Krokki,Kobold,Rogue
Azazra,Kitsune,Sorcerer
Iomiwani,Asari,Wizard
Birch,Arboren,Cleric
Hans,Gnome,Sorcerer
Fœ g_ xi_ng ying,Catfolk,Bard
S’aar,Shadar-kai,Wizard
Enna,Elf,Cleric
Pleochroism,air magic genasi,wizard
Engra Mai'har,Gnome,Ranger
Wat Rea,Fallen Aas
Watford,Human,Gunslinger
"Rory ""Burgess"" Torgenson",Tiefling,Rogue
Raydon Kade,Human,Fighter
Fir'arrathel Adamanthe Eloh,Human,Wizard
Vel'lavandile,Elf,Wizard
Gamaliel,Half-dragon,Fighter
Throggdar the Strange,Dragonborn,Druid
Ilen,Human,Cleric
Ilen,Human,Ranger
Blare,Tabaxi,Bard
Tealeaf,Halfling,Barbarian
Svalbard,Gnome,Bard
Ikthe Denubar ,Elf,Wizard
Cornelius Aquila,Elf,Wizard
Aurelia Malys,Elf,Warlock
Raenara,High Elf,Wizard
Felicia,Human,Cleric
Lord Elrich of Sinnorth,Human,Paladin
Jon Swampson,Human,Barbarian
Arthur,Human,Wizard
Dante,Human,Fighter
Harry Taur,Human,Barbarian
G.P Benatar,Half-orc,Fighter
Jack Straw,Human,Wizard
Grip,Dwarf,Cleric
Anathalistaea mariae,arterian,angel
Rhollo,Dragonborn,Sorcerer
Eisenzahn Avi,Dragonborn,Fighter
Sunshine,Warforged,Bard
Eika,Human,Cleric
Rougsan Halfdan,Dwarf,Cleric
Illiovarus Michael,wood elf,fighter
Nardu,Firbolg,Druid
Morguth Copperbeard,Dwarf,Cleric
Mu'areg Meloric,Drow,Warlock
Ehudoxin Embersong,Human,Wizard
Nibun,human,wizard
Theod,Human,Cleric
Siobhradh Caldonia,Human,Warlock
Rewak,Half-orc,Fighter
Lucca Regalo,Tiefling,Warlock
Marix Eastcote,Elf,Fighter
Shortstack,Human,Fighter
Gar,Human,Fighter
L—netuck,half-elf,bard
Esben Runwicke,
Godfrey,human,fighter
Kripa,human,thief
Lidana Wayward,half-elf,ranger
Earenk ,high elf,bard
Talnean,elf,druid
Arden Sul,human,fighter
Quinne,human,bard
Nara,human,wizard
Oso,human,cleric
Grace,tiefling,bard
Ihiru,elf,druid
Alec d'Aubigny,human,necromancer
Arroca Armiton,dwarf,river / high tide ,barbarian
Amaranthe,elf,druid
Bisk Bellwater,Elf,Wizard
Berenger,Halfling,Cleric
Enora Bellwater,Elf,Ranger
Sabato,human,cleric
Asha,human,monk
Silavel,human,ranger
Mascol,Dwarf,Fighter
Tefol,Human,Paladin
Raythe Grey,Human,Fighter
Vesna Lightpond,High Elf,Sorcerer
Mascol,Dwarf,Fighter
Emadris,Elf,Rogue
Acacia,Firbolg,Druid
Raziros,Dragonborn,Cleric
Zeus,Half elf,Rogue
Felan,Elf,Wizard
Corvus,Half-elf,Rogue
Gau,Gau,Blade 
Arem,Catfolk,Bard
Felan,Elf,Wizard
Bronn Mungi,Human,Barbarian
Sileena Blaize,Tiefling,Warlock
Zeus,Half elf,Rogue
Felan,Elf,Wizard
Bronn Mungi,Human,Barbarian
Aseir,Selkie,Cleric
Vladamon,Elf,Priest
Kaiynster,Half-Elf,Sorcerer
Bjorn Lodestone,Dragonborn,Rogue
Bjorn Talon,Half-Elf,Ranger
Lee Mainge,Human,Fighter
Rani,Drow,Bard
Merrik Hilltopple,Halfling,Paladin
Yanrith,Half-Elf,Bard
Ro,Human,Monk
Warhorn,Half-Orc,Monk
BamBam Stonebreaker,dwarf,Barbarian
Aldorin,Dwarf,Paladin
Kas Cy'Mer,Undead,Druid
Logan Darkcaller,Human,Ranger
Spyderic Gadell,Human ,Warlock
Tim Diggledorn,Halfling,Rogue
Kenniti Delmiriv,Human,Sorcerer
Darius Tarren,Human,Warlock
Feykro Krazt,Ratfolk,Bard
Thog,Half-giant,Barbarian
Vlad Haravindell,Human,Eldritch Knight
Hans Dusseldorf,Human,Bard
Nodarki Skotze,Gnome,Artificer
Hans Dusseldorf,Human,Fighter
Karl Fireforge,Aasimae,Bard
Hans Dusseldorf,Human,Eldritch Knight
Hans Dusseldorf|Asenath,Human,Wizard
Hans Dusseldorf|Asenath,Human,Wizard
Hans Dusseldorf,Human,Eldritch Knight
Nakumo,Goblin,Druid
Hans Dusseldorf|Asan,Human,Fighter
Mochi,Human,Barbarian
Nyamah,Wood Elf,Druid
Mei,Human,Ranger
Konk,Human,Barbarian
Ries Staveback,Half-elf,Ranger
Alina,Human,Fighter
Rognar,Dragonborn,Paladin
Rolen,Brynchanite,Warlock
Ratling Bitsy Sprout Lil Squirt Tiny Pidge Runt Pearl Kit Nyx Squirrel Aster Drip Kicsi Chatterbox Imp Peanut Mite Squeeky,Gnome,Wizard Rogue
Khji,Human,Bard
Nirik Ironfist,Dwarf,Monk
Q Traveler,Half-dragon,Fighter
Rory Rootpot,Gnome,Wizard
Karron,Human,Bard
Eryn,Elf,Wizard
Bryn Draffal,Hill Dwarf,Ranger
Amber,Half-Elf,Warlock
Soraya Underbough,Halfling,Swashbuckler
Kahan,Human,Fighter
Nova,Half-Orc,Barbarian
Kahless Gamesh,Human,Thief
Sorcha,Human,Thief
òronoxys,Whisper Gnome,Rogue
Catnip,Human (shapeshifter),Druid
Tower,Half-Orc,Barbarian
Screex,Gnome,Bard
Anus ,Druid
Dargai,Human,Warrior
Maxvire,Ghostwise Half-Elf,Swashbuckler
Mica-O,Fir-Blooded Aasimar,Cleric
Curacao,Halfling,Bard
Lysander,Half-Elf,Sorceress
Damian,Human,Warlock
Isdirao Ren,Half-Elf,Sorcerer
Roxanne,Half-Elf,Cleric
Nailo,Half-Elf,Cleric
Meilil,Half-Orc,Bard
Geirianth,Human,Wizard
Zephirian,Human,Monk
Yuanqing,Gnome,Ranger
Bingledorf,Dwarf,Fighter
Blessing,Tiefling,Cleric
Morgenstern,Human,Fighter
Anders,Human,Cleric
Pike Coffrey,Halfling,Pirate rogue
Threk Goblinhater,Dwarf,Bard
Tulip the Mad,Human,Wizard
Anton Martell,Half-Elf,Ranger
Solomon,Human,Wizard
Grell Fass,Human,Paladin
Martell,Half-Elf,Ranger
Solomon,Human,Wizard
Grell Fass,Human,Paladin
Grell Fass,Human,Paladin
Niliel,Elf,Wizard
Geirolf,Human,Paladin
Geirolf,Human,Warrior
W. Hens Jack,Human,Fighter
Bjorn,Human,Fighter
Bjorn,Human,Fighter
Bjorn,Human,Fighter
Bjorn,Human,Fighter
Camelia,Half-elf,Sorcerer
Sigurd,Half-orc,Fighter
Kazis Flint,Human,Wizard
Thond'nia Spyriel Ulrick Sumagus Tarls gulesham sileval,Gnome,Wizard
"Kursh, the guffaw" --- Althi,Drow (theif), "Gaffer, guffarian of the ___________"
Sudz Tawalz,Half-Orc,Fighter (Aegis)
Byron,Human,Fighter
Xarann,Drow,Cleric
Hanurar Swiftaxe,Dwarf,Barbarian
Gulag,Orc,Barbarian
Ryo,Human,Ranger
Gyal,Orc,Rogue
Woolworth,Elf,Fighter
Stabby,Halfling,Bard
Sighar,Human,Fighter
Sighar,Human,Fighter
Slipshod,Human,Fighter
Tabu,Human,Fighter
Gurbangi Bari,Orc,Bard
Aislann Bonesong,Human,Fighter
Foloch Bari,Orc,Fighter
Lapis Voidsie,Human,Ranger-thief
Ceria,Half-Elf,Bard
Kulrug,Goliath,Fighter
Maximus,Human,Wizard
Kole Telios,Half-Elf,Wizard
Amrod,Human,Warrior
Beryl Toussud,Half-Elf,Thief
Nul Grul-l8n,Gnome,Wizard
Tavelorn,Elf,Ranger
Edward the Conjurer,Human,Librarian
Lianna Black,Human,Wizard
Fausta Long-Clan,Elf,Ranger
Dios,Human,Warrior
Aelar Anastasia,Elf,Ranger
Lucia,Human,Monk
Mxyzptlk,Halfling,Warlock
Lun atanylson,Halfling,Warlock
Che Guevara,Human,Bard
Aten,Human,Paladin
Ernest ÒÒÓ the�¡ltive elf",Human,Monk
Pope Francis,centaur,warpriest
Oa,half-elf,warlock
Kor'Gan,dragonborn,paladin
Spiranus ferrae,doppelganger,fighter
Vaalia Jassan,human,Assassin
Ravenna Amanodel,Elf,Wizard
Meridee Whitestar,Human,Cleric
"Gamtis ""Piss"" Templebell",dwarf,ranger
Bavel,Half-dragon,Barbarian
Dunkyb,Dwarf,Wizard
Tuffgar,Half-orc,Barbarian
Imbogr,dwarf,ranger
Izthander Erskine in Murk,Tiefling,Bard
Valanthe Silvermantle,Elf,Druid
Adhel,Human,Wizard
Jasper,Dragonborn,Cleric
Merill Silvermantle,Elf,Ranger
Kethra,Half-elf,Rogue
Exeter,Elf,Ranger
Halls Ashlander,Half-elf,Mystic
Callum Nee,Human,Monk
Krissada Caraman,Human,Barbarian
Penren,Half-elf,Bard
Davious Heterocles,Dwarf,Cleric
Orylvann,Dwarf,Fighter
Tenebrae Nailo,Drow,Swashbuckler
Bonta,Gnome,Sorcerer
Mag Ma•lo,Half-orc,Fighter
Taysikuu,Human,Cleric
Dyvia Fyne,Fire Genasi,Wizard
Tayga Shakyun,Yuan-Ti,Ranger
Drumlin,Human,Monk
Mascol,Dwarf,Fighter
Dim,Human,Fighter
Alexander,Half-orc,Fighter
Mascol,Dwarf,Fighter
Dyvia Shakyun,Yuan-Ti,Ranger
Drumlin,Human,Fighter
Dim,Human,Fighter
Lycan,Firbolg,Druid
Armistice,Elf,Wizard
Alexander,Half-orc,Fighter
Mascol,Dwarf,Fighter
Mazmur,Human
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Sizzling Sally,Firbolg,Ranger
Tabbitha Black,Firbolg,Bard
Nodrineth,Drow,Sorcerer
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Nogar,Dwarf,Fighter
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Nogar,Dwarf,Fighter
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Fall Sale,Firbolg,Druid
Fall sale,forester dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
Fall sale,dwarf,fighter
New Day,Half-Nymph,Fey
Preybomberman,Gnome,Wizard
Lirrasha Ricantaur ,Half-elf,sorcerer 
Hadeyr Elaphine,Half-elf,Cleric
Firble Cavedust,"Half-elf, half-drow",Thief
Mera,Human,Fighter
Mera,Human,Thief
Sunshine,Tiefling,Arcane Trickster
Ferax,Half elf,Paladin
Atum Nephermande,Human,Bard
Firbolg,Dwarf,Barbarian
Gayatri,Half-elf,Bard
The Blue Palsy,Half-orc,Paladin
Kristof Silverhand,Aasimar ,Cleric
Shandri Nemeia,Human,Rogue
Taren,Halfling,Rogue
Anehne,Elf,Ranger
Gael,Half-orc,Blood Mage
Zephyr,Silver Dragon,Cleric
Ithanid,Human,Fighter
Koranna,Halfling,Rogue
Hannah,Aasimar,Paladin
Keagan Hornswaggle,Human,Cleric
Korrin Ironhorn,Dwarf,Cleric
Kyrria Sunstrider,Human,Druid
Forget-Me-Not,Goblin,Warlock
Koranna Sunstrider,Human,Rogue
Argenon Jririx,Goliath,Paladin
Binyamin,Elf,Paladin
Resurge,Human,Fighter
Artrue ,Human,Wizard
Brynn,Half-elf,Rogue
Logris,Half-Elf,Monk
Rogmesh,Half-Orc,Cleric
Trak Duncan,Half Orc,Fighter
Mike The Magnificent,Human,Fighter
Augustanna Fortune,half-elf,bard
Praetoria,Half-elf,Rogue
Praetoria,Half-Orc,Rogue
Qi Pao,Half-orc,Paladin
Reeve,Gnome,Wizard
Jin Fu,Human,Monk
Lowluna Ambershands,Halfling,Bard
Brynn,Half-Elf,Fighter
Sneakshot Grumbleguts,Goblin,Druid
Yin ,Goblin,Rogue
Lia,Human,Rogue
Plug,Dragonborn,Monk/Cleric
Micah Starbreeze,Half elf,Sorcerer
Krasnodar,Human,Wizard
Tyril Tallguy,Firbolg,Cleric
Maximus,Human,Fighter
Vorrin,Elf,Fighter
Kam Cloistered,Lizardfolk,Fighter
Hans,Half-Elf,Fighter
Leanora,Half-Elf,Druid
Tarak Dune,Dwarf,Cleric
Rockefeller,Human,Ranger
SteelGate,Ibixian,Transmuter
Zen,Warforged,Soulknife
Maekrix,Dragonborn,Fighter
Jax,Dragonborn,Bard
Bruz,Dwarf,Fighter
Storund,"Half-elf, half-dwarf",Fighter
Usalonica,Half-elf,Warlock
Taia YIlliria,Elf,Druid
Usalonica,Half-elf,Warlock
Fyonn Greatforge,Dwarf,Wizard
AzarCain,Dragonborn,Sorcerer
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Usbuddy,Goblin,Ranger
Brundorff Stoutgirth,D
Tlaxcala Graybird,elf,wizard
Rurantis Doxycar,dwarf,sorcerer
Amber Silverthorn,halfling,rogue
Azazel Jones,Tiefling,Warlock
Mervin the Gnome,Human,Rogue
Thessily,Elf,Wizard
Kolomon Porphos,Tiefling,Paladin
Thessily Wente,Elf,Ranger
Thessandra,Elf,Cleric
Iatrogen,Human,Rogue
Kulit,Gnome,Rogue
Uthall Unhild,Half-Orc,Cleric
Uthallur Protector,Elf,Ranger
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Uthallur Vigil,Elf,Cleric
Amber Rose Whisperfrost,Wood Elf,Ranger
Minskas Whisperfrost,Half Orc,Paladin
Sigtryar,Human,Wizard
Sseth,Half elf,Bard
Thaviel Nailo,Dark Elf,Wizard
Ardat Kopek,Half elf,Rogue
Raevori Abriel,Aasimar,Paladin
Dandle DeBryde,Gnome,Ranger
Setty Diddleknuckle,Halfling,Rogue
Davious Gimble,Halfling,Sorcerer
Pearl Skamel,Half-Elf,Bard
Setty Diddleknuckle,Halfling,Ranger
Spirit eater,Half-Orc,Champion
Setty Diddleknuckle,Halfling,Ranger
Setty Diddleknuckle,Halfling,Ranger
Pearl Skamel,Half-Orc,Champion
Setty Diddleknuckle,Halfling,Ranger
Setty Diddleknuckle,Halfling,Ranger
Setty Diddleknuckle,Halfling,Ranger
Setty Diddleknuckle,Halfling,Ranger
Setty Diddleknuckle,Halfling,Ranger
Setty Diddleknuckle,Halfling,Ranger
Setty Diddleknuckle,Halfling,Ranger
Guile,Human,Barbarian
Din,Human,Wizard
Mawrthi ,Half-orc,Antipaladin
Packinin,Human,Antipaladin
KAthrud,Human,Fighter
ALIEN,Human,Warlock
SHE HAVIER,Human,Warlock
Jas,Human,Monk
STAR,Human,VehMaster
STARVE,Human,VehMaster
STARVE,Human,VehMaster
STARVE,Human,VehMaster
STARVE,Human,VehMaster
STARVE,Human,VehMaster
STARVE,Human,VehMaster
STARVE,Human,VehMaster
Aarfield Darkfeather,Halfling,Bard
Ober Greenbelly,Halfling,Rogue
Shawna Blackbeard,Dwarf,Cleric
Dorian Freyd,Human,Sorcerer
Dean Quill,Human,Bard
Jarlorn Ironfist,Dwarf,Fighter
Jarlorn Ironfist,Dwarf,Fighter
Trevor Freeleaf,Elf,Fighter
Nathan Silver,Human,Fighter
Gum,Gummon,School Boy
Paul Fin,Human,Ranger
Kromagg,Half-Orc,Fighter
Scramasax,Goblin,Paladin
Vesk,Tiefling,Rogue
Kheus,Human,Monk
Honesga Fireforge,Dwarf,Wizard
Jolai Rein,Tiefling,Warlock
Hrognarr,Human,Wizard
Grognak,Half-orc,Barbarian
Horus Bertoldt,Halfling,Sorcerer
Imara Stormwind,Human,Paladin
Iluifur Rahman,Human,Fighter
Melchior Asmodai Gareth Lightfoot,Human,Cleric
Pike Trickfoot,Halfling,Rogue
Carpe Culus,Human,Monk
Grubble Cotsword,Halfling,Ranger
Pyokwelt,Halfling,Fighter
Rashan ,Tiefling,Rogue
Malika,Human,Sorcerer
Zanna,Human,Cleric
Delgos,Human,Wizard
Iphigenes S.Hirsii,Skeleton,Cleric
Laucian Quilfein,Hellfire Tiefling,Fighter
Thud Filiger,Half-Fang,Barbarian 
Apollo Tramadolux,Air genasi,Bard
Bruin Bombastus,Half elf,Warlock
Crazy Gold,Human,Fighter
Spanka,Half-orc,Barbarian
Carl,Human,Fighter
Alisem,Half-Elf,Ranger
Bruz,Human,Wizard
Ezhelya,Human,Cleric
Gar,Half-Orc,Fighter
Longreach,tiefling,rogue
Maki,human,rogue
Longreach,tiefling,ranger
Longreach,tiefling,sorcerer
Longreach,tiefling,warlock
Riverwind,human,bard
Alain,human,cleric
Longreach,tiefling,warlock
Riverwind,human,cleric
Longreach,tiefling,bard
Riverwind,human,ranger
Riverwind,human,barbarian
Riverwind,human,barbarian
Longreach,tiefling,rogue
Necromancer,human,wizard
Lizardborn,orc,barbarian
Abraxos,human,cleric
Verad,Dragonborn,Transmuter
Theresia,Human,Rogue
Akachi,human,wizard
Jolana,human,cleric
Archimedes,human,Wizard
Archimedes,human,Wizard
Archimedes,human,Warrior
Ripley,dwarf,fighter
Eknoron,dragonborn,paladin
Etwys,drow,cleric
Zeno,halfling,monk
Fenris,half orc,cleric
Ikriet,dwarf,fighter
Neva,ogre,druid
BamBam,gonzo,bard
Veshu,goblin,fighter
Vashu,goblin,mage
Raegal Zur,Half elf,Druid
Sora Daardendrian,Dragonborn,Druid
Ishmael Gru'Dorr,Half-Drow,Wizard
Surkiel Mo'Kerne,lingain,paladin
Gherdy Goldheart,Hill Dwarf,Cleric
Minaffrey,Halfling,Thief
Nodrin Leafwalker,Halfling,Ranger
Ghab,Kobold,Barbarian
Zoya,Human,Necromancer
Mog,Half-Orc,Fighter
Scalp phage,Orc,Ranger
Zaya,Orc,Cleric
Ashthorn,Human,Cleric
Sariel,Elf,Rogue
Bart,Dwarf,Barbarian
Lurai,Dragonborn,
Half-orc,Half-Ranger
Half-orc,Half-Ranger
Elenor Arfan,Half-Elf,Wizard
Darin Silverleaf,Half-Elf,Bard
Kip Bonesnapper,Kobold,Wizard
Gar Numenk,Half-Orc,Paladin
Jak Haskill,Half-Elf,Sorcerer
Leonard Nimble,Halfling,Bard
Berenice,Half-Elf,Sorcerer
Maw Rumen,Half-orc,Bard
Amirah,Half-Elf,Sorcerer
Elenor Arfan,Half-Elf,Sorcerer
Leonard Nimble,Halfling,Bard
Scarlet Baggins,Halfling,Ranger
William Holder,Half-Elf,Cleric
Cypris Firelake,Dragonborn,Monk 
Inrea Blackwood,Half-Elf,Sorcerer
William Holder,Half-Elf,Cleric
Sydney Murch,Half-Elf,Cleric
Jack Blackwood,Half-Elf,Ranger
Firrith,Half-elf,Druid
Sariel,Tiefling,Ranger
Lucien Meniati,Half-elf,Wizard
Sqib Ana,Half-elf,Bard
Paloma,Half-elf,Wizard
Aramril,Half-elf,Rogue
Klein Reinstein,Half-Elf,Fighter
Caliga Tijem,Human,Thief
Pra'amek,Half-Orc,Druid
Adeynn Adeyn,Half-elf,Rogue
Boghat,Half-orc,Barbarian
Unai Haurayn,Half-orc,Paladin
Torvald,Half-elf,Paladin
Haliyah,Half-orc,Fighter
Zain,Half-orc,Rogue
Calamity,Half-Elf,Bard
Thistle,Half-orc,Fighter
Grace,Half-Elf,Cleric
Grace,Half-Elf,Rouge
Grace,Half-Elf,Cleric
Azure,Half-elf,Rogue
Tabun,Half-Orc,Bard
Iresh Chastity,Half-elf
Blodestarp,Elf,Ranger
Sargesh,Human,Wizard
Ekarr Kel Karson,Dwarf,Cleric
Thrak,Dragonborn,Barbarian
Ral'aheda,Iriadon,Paladin
Brunde,Air Genasi,Cleric
Phoenix,Warforged,Rogue
Brunde,Air Genasi,Monk
Standing Water,Elf,Bard
Artem Gaspar,High Elf,Wizard
Vlad Grubb,Halfling,Rogue
Eros,Dragonborn,Cleric
Jurock,Gnoll,Bard
Vonda Thorbak,Half-orc,Barbarian
Anry Stoutfellow,half-elf,barbarian
Nissa Ravenswood,half-dwarf,rogue
Primyn Nackle,Gnome,Wizard
Ghyr,Goat,Fighter
Ned Goldstream,Human,Bard
Fallsor,Half-Elf,Bard
Ragnar FuckFist,Dwarf,Monk
Dhryss Fholloway,Dwarf,Fighter
Fuckfist,Dwarf,Fighter
M_m,Half-Orc,Fighter
Molly,Human,Wizard
Victrar,Elf,Fighter
Wildate,Human,Monk
Gauz Gšrden,Dwarf,Fighter
Ranel,Human,Monk
Rena Maegara,Human,Fighter
Rea Morrigan,Human,Fighter
Astra Omorfia,Human,Wizard
Triel Novena,human,fighter
Kannad,Elf,Ranger
Gustštan,Human,Barbarian
Aven,Bear,Druid
Roan Wycke,Human,Rogue
Nameless,Shade,Elf,Rouge
Ilvaria,Drow,Rogue
Fortune,Tiefling,Cleric
Ceoles,Half-elf,Magic-user
Talon,Half-Elf,Rogue
Lucia,Half Orc,Fighter-Mage
Ceilu Waywocket,Half-elf,Bard
Mal,Drow,Rogue
Malur,Half Human,Bard
Gretchen Himmelhir,Human,Wizard
Dalek,Human,Monk
Dalek,Human,Monk
Sirell,Human,Warrior
Fall,human,druid
Ebris von Silberberg,Human,Cleric
Viktor von Raspendale,Human,Ranger
Dalek,Vishkanya,Rogue
Adolf Mao Stalin Hussein,Human,Warlord
Pogranax,Half-Orc,Paladin
Xancor,Half-orc,Paladin
Kronos,Half-orc,Paladin
Muhammed,Human,Monk
Goddard,Gnome,Barbarian
Albatross,Human,Sorcerer
Zoch Lothar,Human,Paladin
Mirabelle Enomoto-Farrath,Elf,Sorceress
Prince Amalgam Thulathra,Elf,Wizard
Trogdor,Dwarf,Cleric
Sir Grand Master of the Grand Ballroom Draconic Grand Master of the Masoretic Ballroom Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Masoretic Ballroom,Draconic Grand Master of the Mas
Shadow Puppy,Tabaxi,Thief
Xysin,Feyzard Eterna,Pharaoh
Feng Li,Changeling,Phoenix sorcerer
Nora Chillwind,Human,Rogue
Miku,Halfling,Rouge
Nora Chillwind,Human,Rouge
Fangala Dukhmir,Dragonborn,Barbarian
Bjorn Lodestone,Dwarf,Barbarian
Krosis in the Morning,Tabaxi,Druid
Syra,Warforged,Wizard
Astra Skysong,Half-elf,Bard
Thrud,Half-orc,Barbarian
Kole Allentown,Dwarf,Fighter
Sevenillamuther,Half-elf,Warlock
Rhyisjh,Dragonborn,Wizard
Theresia,Human,Wizard
Kithri Greenleaf,Gnome,Bard
Arland,Half-elf,Fighter
Blodwen Stonefoot,Halfling,Rogue
Rohkiri Thefner,Human,Warrior
Thrakk Gunnerson,Dwarf,Fighter
Rona Ferre,Tiefling,Druid
Valanyn,Human,Rogue
Viktor Gargamel,Human,Wizard
Delgoss Nackle,Dwarf,Bard
Geirianth Senn,Wood elf,Druid
Auriel Zulal,Dark elf,Assassin
Sansorial Askelion,Half-elf,Ranger
Jillian Cruse,Halfling,Rogue
Gamahuche Renshaw,Dwarf, Cleric
Hoi Heartorb,Human,Bard
Kylian Yvenson,Half-orc,Fighter
Tanith,Ifrit,Mystic
Angel,Human,Mage
Regina Thornbarrow,Halfling,Sorceress
Cynn Ravenwyr,Human,Fighter
Finnypawn,Tiefling,Warlock
Torvald,Half-elf,Ranger
Tharivol Meliamne,Elf,Rogue
Nightbreeze,Drow,Rogue
Torvald,Half-elf,Ranger
Plug,Goblin,Clockwork Mechanic
Theris Thunderfist,
Sulmaegarth Vrothil'ikar,Half-Elf,Ranger ,Pyromancer
Alura Sinister,Human,Fighter
Sekou,Human,Wizard
Mayra Stormcaller,Human,Witch
Krulk Wolfcaller,Human,Wizard
Mayra Stormcaller,Human,Wizard
Juneanna,Half-Elf,Warlock
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Juneanna Stormcaller,Human,Wizard
Puncho,Human,Rogue
Tequila Davis,Tiefling,Rogue
Rilla JEx,Tiefling,Warlock
Rosha,Halfling,Rogue/Warlock
Sargesh,Dragonborn,Warden
Oddrey Halflings,Human,Rogue
Sahsatchas,Human,Sorcerer
Sahsatchas,Human,Sorcerer
Otha,Human,Wizard
Laoresh,Half-Elf,Cleric/Monk
NARRATOR: Aldric Blackrock,Half-elf,Cleric
Bohunk,Half-Orc,Barbarian
Spyder,Human,Fighter
Xamnir,Human,Thief
"Waywof "Boozer" Longbottom",Halfling,Bard
Xanthippe Nailo,Wood Elf,Druid
Quib Keebler,Halfling,Ranger
Wren,Wood Elf,Druid
Bunk,Wood Elf,Ranger
Bunk,Wood Elf,Ranger
Xavier,Wood Elf,Druid
N/A,Wood elf,Druid
Dremki,Wood Elf,Druid
Spurlock Kennin,Halfling,Rogue
Spurkle,Gnoll,Rouge
"Boozer Longbottom, Esquire",Halfling,Ranger
Aukan the Red,Human,Wizard
Lock on an Eye,Tabaxi,Wizard
Rukhl,Hobgoblin,Fighter
Derringer,Half-elf,Bard
Gikiga,Human,Druid
Chase Tales,Tiefling,Rogue
Ishayle,Half-Elf,Paladin
Chase Tales,Tiefling,Rogue
Ben Affleck,Human,Wizard
Inanna,half-elf,bard
Chase Tales,Tiefling,Rogue
Raisha Afixity,Human,Warlock
Llewellyn Corwood,Human,Wizard
Nessa Wren,Elf,Rogue
Firralynn ,Elf,Wizard
Fincern Applewood ,Half-elf,Druid
Nottoman,Human ,Barbarian
Storon Humber,Human,Barbarian
Samuel Marsh
Horace,tiefling,sorcerer
Makkuro Belanor,tiefling,bard
Jalen evans,human,fighter
DJGernstone,dragonborn,bard
Zineke,elf,warlock
Serdeo Galilei,human,paladin
Maggie Crackergum,Halfling,Bard
Hans Oliver,Half-elf,Fighter
Sydney Mica,Gnome,Druid
Henderson,Human,Fighter
Powell,Dwarf,Fighter
Bayard Henshrow,Human,Fighter
Ellick,Halfling,Rogue
Sklar,Half-orc,Fighter
Coriander,Half-elf,Rogue
Gernius,Elf,Fighter
Hans,Human,Fighter
Henry,Elf,Fighter
Lucian,Elf,Fighter
Feyzula,Half-celestial,Spellsword
Aeldari,Drow,Wizard
Vanz Ornstag,Elf,Fighter
Martin,Human,Druid
Myrthin Thuldrvasse Dusktung,Elf,Ranger
Hari,Tiefling,Ranger
Reem,Half-elf,Ranger
Zakool,Goliath,Fighter
Dave,Human,Fighter
Dave,Human,Fighter
Alex,Human,Fighter
Tharivol Lorethian,Half Elf,Ranger
Diya,Human,Swordmage
Auriam Dunhlaven,Human,Wizard
Amber D'Vinigrette,Wood Elf,Ranger
Felix Colgrave,Human,Fighter
Anzu,Aarakocra,Monk
Tia,Half-elf,Rogue
Morgana,Tiefling,Paladin
Preyu,Human,Monk
Rake Hacker,Dragonborn,Cleric
Eltoris Admar,Elf,Paladin
Caleb,Human,Alchemist
Yuki-san,Human,Witch
Applonia,Tiefling,Fighter
Torthos Senzoo,Half-elf,Cleric
Nai Lim,Aasimar,Bard
Paul Fin,Aasimar,Magus
"""Shay"" Beshaba Mill
Half-Orc,Half Orc,Bard
Aeon,Elf,Druid
Irian Horseman,Half-Elf,Fighter
Dea Nadal,Human,Paladin
Vladimiristin Mofundi,human,wizard
Ghibli Unicorn,Half-Orc,Barbarian
Kyrria Tel-Avren,Kitsune,Gyaru
Ithyria,Elf,Ranger
Ethel,Half-Elf,Paladin
Krutz,Goblin,Ranger
Rashidaar Ahriman,Dragonborn,Bard
Berthon Ironside,Gent-Orc,Fighter
Bert,Goblin,Paladin
Balthazar Ashmodai,High Elf,Wizard
Fecaluruel ,Half-elf,Cleric
Zsus Nosua,Human,Wizard
Bert,Goblin,Barbarian
Tamora Pannenbakken,Halfling, Thief
Cara Soulflenser,Human,Rogue
Wazzok Flesheater,Half-Orc,Wizard
Solazzh,Lari,Cleric
Zin Siannodel,Elf,Bard
Ithilwen,Half-Elf,Warlock
Brynn,Half-Elf,Druid
Tathar,Tiefling,Wizard
Gabriel,Human,Fighter
Gurge Bane,Kobold,Shadow Paladin
UThra,Dragonborn,Fighter
Calisma,Halfling,Cleric
Calisma,Halfling,Cleric
Grazi,Half-Orc,Bard
Morokt Ironforge,Dwarf,Monk
Ramdao,Half-Elf,Sorcerer
Sriyesh,Yuan-ti,Wizard
"""Shay"" Beshaba Milliner",Human,Ranger
Khaz,Half-orc,Rogue
Lori,Human,Warlock
Kothlar,Half-Orc,Barbarian
EA,Eladrin,Rogue
Chi-Tik,Thri-Kreen,Monk
Regir,Dwarf,Fighter
Glor,Human,Fighter
Avium Fiallyara,Elf,Wizard
Izthander,Human,Cleric
Engelica,Human,Fighter
Elspeth,Human,Fighter
Rilla Navratilova,Teifling,Bard
Giovanni Derrara ,Human,Bard
Avverin Darkreach,Human,Cleric
J'as Delvinege,Elf,arships,Inquisitor
Avverin Derrara ,Human,Fighter
Avverin Derrara ,Human,Warlock
Izthander,Human,Wizard
Devanaman,Human,Cleric
Gunnar Satyn,Half-Elf,Bard
Tiberius,Human,Ranger
Delorn,Human,Warlock
Norsebeard,Dwarf,Barbarian
Ginny,Halfling,Bard
Thistle,Tiefling,Druid
Nuffin,Human,Paladin
A Who,Half-Elf,Thief
Thistle,Tiefling,Druid
Packin Longstroll,Halfling,Ranger
UH-den,Half-elf,Ranger
Packin Longstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Packin Shortstroll,Halfling,Ranger
Little Brother Ender,Human,Cleric
Abe Amastacia,Half-Elf,Sorcerer/Ranger
Bae d'Ali,Human,Bard
Anakin Skywalker,Human,Rogue
Bell Ember,Orc,Fighter
Chelsey,Halfling,Ranger
Kyra,Human,Rogue
Corrin,Human,Wizard
Sora Skylar,Half-elf,Bard
Fek,Human,Wizard
Tyrion,Human,Fighter
Brynn,Half-elf,Paladin
Morthai Greycastle,Dwarf,Druid
Gnal Thul,Human,Fighter
Kruegar Ouspin,Gnome,Wizard
Zakith Vondias,Human,Rogue
Fionnuala ,Half-Orc ,Cleric 
Amaru,Human,Warrior
"Oraen ""The Red Dragon""",Half-Orc,Eldritch Knight
Nil,Changeling,Favored Soul/Gideon,Changeling,Oracle
Merrik Durkheim,Human,Fighter
Sashelea Silentbone,Tabaxi,Fighter
Orrea Ricont,Human,Fighter
Cadno Llewellyn,Human,Cleric
Lilith,Half-elf,Warlock
Sapphire Regulus,Half-elf,Wizard
Lily,Half-elf,Cleric
Lucent Noen,Human,Thief
Roseanna of the Thorn Princess,Human,Cleric
Sabine the Gentleaze,Human,Cleric
Arlainna of the Quick,Human,Wizard
Valarenka A Valkenwart,Senpai of the Beginning?,Human,Ranger
Sabine the Gentleaze,Human,Cleric
Ander Brightstar,Human,Cleric
Luarrk,Hobgoblin,Fighter
Furlongsjog,Dwarf,Bard
Garvan T'Nok,Human,Rogue
AQUarelia Stormwind,Avarna,Rogue
Lori,Human,Warlock
Sorcha,Human,Cleric
Grimm Gobbins,Human,Fighter
Gallius,Human,Fighter
Blorp Blerg,Gnome,Wizard
Sir Poppin Loksalotivel,Elf,Swashbuckler/Bard
Loki Pooh,Halfling,Bard
Alaric ,Human,Bladesinger 
Pvidulus Ader,Human,Barbarian
Xar,Human,Bard
Loki Pooh,Halfling,Bard
Alaric ,Human,Bladesinger 
Solaris
Darkwing,Drow,Rogue
Faline Weir of Lighthome,Half-Elf,Bard
Lugh Anarian,Human,Paladin
Grace Blackstone,Human,Rogue
Nadarrin,Dragonborn,Cleric
Asha,Half-Dragon,Barbarian
Hadiya,Half-Dragon,Bard
Neva,Human,Barbarian
Arishann Kerrhylon,Dragonborn,Paladin
Tinker,Warforged,Warblade
Aelya Siannodel,Elf,Warlock
Hellbender,Orc,Brawler
Lubbregy,Human,Cleric
Lubbregy,Human,Cleric
Lunatic,half-elf,bard
Uhara,Human,Rogue
Umara,Human,Rogue
Umara,Human,Rogue
Umara,Human,Rogue
Umara,Human,Rogue
Umara,Human,Rogue
Ok,Orc,Barbarian
Umara,Human,Rogue
Umara,Human,Rogue
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Ok,Orc,Barbarian
Zandor,Half-orc,Paladin
Kai,Half-elf,Rogue
Athranby,Wood elf,Druid
Amber Anvilborn,Dwarf,Rogue
Razorsky Tagreal,Chelybug,Bard
Tsordaek,Tiefling,Warlock
Kreech Inkbrig,Human,Fighter
Bloodstained,Tabaxi,Barbarian
Amber Vashin,Half elf,Rogue
Grizzathurnax,Human,Ranger
Boront,Orc,Fighter
Hydra,Human,Rogue
Fargrim Dar,Half-Orc,Paladin
Ardamar,Half-Elf,Paladin
Aldorin,Dwarf,Rogue
Lily,Human,Fighter
Polly Quills,Forbear,Rogue
Saint, Originman,Fighter
Ebonyn Tensay,Human,Wizard
Ting Ting,Half-elf,Bard
Morwenna Ravenwood,Tiefling,Paladin
Marek Nailo,Half-elf,Wizard
Halgo Trusgar,Half-orc,Fighter
Ardent Venture,Human,Sorcerer
Aluvas Frozenblood,Wood elf,Ranger
Celeste Starberry,Human,Cleric
Jayden Treebranch,Halfling,Rogue
Ardenhjor Manderkrod,Dwarf,Fighter
Mors Arkalis,Tiefling,Rogue
Cerith Warskarana,Human,Warlock
Killian Half-Heart,Half-Elf,Bard
Tevya,Human,Bard
Myrrh Mydwin,Half-orc,Ranger
Delphine Half-Fey,Half-elf,Cleric
Angus,Human,Wizard
Sudz,Half-orc,Barbarian
Marcius,Human,Rogue
Hebjla,Half-orc,Fighter
Idlewild South,Human,Ranger
Tarhun,Half-Orc,Paladin
Feycroft,Half-elf,Cleric
Quee,Human,Druid
Chai Hwan,Half-Elf,Cleric
Dave,Human,Fighter
Waldorf,Faun,Bard
Kreuz,Gnome,Wizard
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Waldorf,Flemish,Fighter
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Figaro,Halfling,Rogue
Elfrigard Belokeit,Half-elf,Bard
Dryad,Half-Elf,Druid
Aelfsbane,Human,Rogue
Dagfinn,Half-elf,Barbarian
Milden Vyrs,Half-elf,Paladin
N'lorva Trueblad,Orc,Bard
Bors,Half-orc,Barbarian
Iorad,Human,Fighter
Rzasirind,Machine,Wizard
N'rotherthan,Half-elf,Warlock
Xak Whose-Breath-Palm,Dragonborn,Paladin
Viam Jan’s son,Human,Goliath,Cleric
Bors,Human,Fighter
Sjšgren,Half-orc,Barbarian
Astalum,Half-elf,Bard
J'soud Flaskguard,Dwarf,Bard
XakshÕbjrns,Orc,Bard
Laghrim‘n Laarhain,High Elf,Ranger
Liath Althyrath,Half-Elf,Fighter
Liatharia,Half-Elf,Bard
Hjern Gronskull,Goliath,Fighter
‡Calldr Frostbeard,Half-Elf,Cleric
‡Calldr Frostbeard,Half-Elf,Fighter
Shak‡fi,Goliath,Barbarian
Runekyna Lekalen,Drow,Warlock
Ola'im,Half-elf,Warlock
Shakoslov Zivvi,Goblin,Rogue
Viztar,Megidolite,Wizard
Qaro Talon,Half-Orc,Bard
Ujack Bloodmare,Half-Orc,Barbarian
Jorthos Brandystrand,Human,Fighter
Lilith Greywald,Human,Paladin
Ronk,Hobgoblin,Fighter
Mirellia Nightborn,Drow,Rogue
Korrahn Garthwind,Half-elf,Ranger
Darius,Human,Fighter
Sasha Fierce,Human,Ranger
Dayna Whisperwood,Moon Elf,Rogue
Calyx,Elf,Druid
Quick,Goblin,
Human,Barbarian
Izkan,Catfolk,Rogue
Wistan,Tiefling,Monk
Namari,Catfolk,Sorcerer
Hithaerandir El'Gar,Elf,Wizard
Aquarelle,Elf,Ranger
Behtis El'Sr.,Half-orc,Paladin
Ori Faerhel,Aasimar,Paladin
Jiralinn Iresh,Half-Elf,Warlock
Aurelia Amastacia ,High Elf,Bard
Aurelia Amastacia ,High Elf,Bard
Caelumeth,High Elf,Warlock
Landgraf Renegade,Dark Elf,Rogue
Reyna Meliosa ,Wood Elf,Sorcerer 
Rev Jakub von Humblestone,Gnome,Rogue
Landgraf Renegade,Dark Elf,Rogue
Landgraf Renegade,Dark Elf,Rogue
Landgraf Renegade,Dark Elf,Rogue
Landgraf Renegade,Dark Elf,Rogue
Landgraf Renegade,Dark Elf,Rogue
Landgraf Renegade,Dark Elf,Rogue
Landgraf Renegade,Dark Elf,Rogue
Rikka Shatterheart,Tiefling,Wizard
Drakkar Haskrem,Catfolk,Rogue
Rajcha the Bold,Gnome,Cavalier
Grem Ironheart,Half-Orc,Barbarian
Hargrave Innstrad,Human,Cleric
Ral Cortan,Human,Ranger
Athena Wexler,Half-elf,Ranger
Anathema,Half-Elf,Warlock
Melisandre,Drow,Rogue
Fardor Bashforth,Halfling,Rogue
Forge - A asm Tch Tch,Tech-Sketch
Meian Alderweyr,Drow,Fighter
Meian Alderweyr,Drow,Fighter
Meian Aasimar,Human,Bard
Meian Aasimar,Human,Barbarian
Meian Aasimar,Human,Cleric
Meian Aasimar,Human,Warlock
Meian Aasimar,Human,Cleric
Meian Aasimar,Human,Warlock
Meian Aasimar,Human,Cleric
Human,Wizard
Bloodnestrel,Elf,Sorcerer
Faelin,wood elf,ranger
Argenon,Wood elf,monk
Ralstrik,Half-Fiend,Warlock
Ralstrik,Half-Fiend,Wizard
Urgrazi,Zerg,Barbarian
Nazarr,Human,Cleric
Igg,Gnome,Wizard
Kalinrat,Elf,Wizard
Athos Farondor,Elf,Paladin
Hans,Human,Druid
Long,Water Genasi,Druid
Ender,Human,Monk
Ea,Half-orc,Barbarian
Krugh,Half-orc,Cleric
Kurtz Dragonfable,Half-Orc,Wizard
Bartholomew Corville,Human,Wizard
Wynnawren Berrybink,Human,Wizard
Flint Firebrand,Elf,Ranger
Althea,Elf,Druid
Jorek Largsdottir,Human,Fighter
Queequeg,Rokovokian,Fighter
Okolongi,Aren,Druid
Scion Olas,Human,Fighter
Reign Skylark,Moon Elf,Thief
Looker,half-orc,Paladin
Baylof,Gnome,Bard
Runak,Vesta,Swashbuckler
Kal-Dash,Human,Bard
Boggart,Half-orc,Barbarian
Liadon Talalead,Half-Elf,Warlock
Xathar,human,warlock
Dizzt Do'Urden,Drow,Ranger
Bahspec,Gnoll,Ranger
Molasses Pedestrian,Tabaxi,Rogue
Celandinas,Human,Ranger
Garret P. Mules,Halfling,Ranger
Llewellyn Heavymetal,Human,Ranger
Shula Shaga,Dragonborn,Sorceror
Rayna,Human,Rogue
Furlong Chaosaxe,Dwarf,Fighter
Blendarr,Dwarf,Fighter
Jungle,Tabaxi,Ranger
Ivandis,Elf,Paladin
Tan,Half
Human,Wizard
Risen Dragonborn,Human,Wizard
Tawni Hollowood,Halfing,Druid
Shrill Cloakhaven,Halfing,Rogue
Mikyran Stormrunner,Halfling,Barbarian
Hwalyd Half-aquatic,half-drow Half-drow Half-drow Half-drow Half-drow Half Guard Warmaiden,Tiefling,Warlock
Korigen Stormwind,Human,Ranger
Belkin,Half-orc,Ranger
Feng Xiao,Halfling,Rogue 
Yu Shu Lian,Half-Orc,Monk
Qin Fu Oldwich,Human,Wizard
Huwayi,Human,Monk
"Cuthbert ""Hickory"" ",Human,Fighter
Yuexuala Ashtar,Human,Barbarian
Yanfeng,Human,Cleric
Long Man Falcon,Elf,Ranger
Bumper,Gnome,Mage
Miurik,Human,Fighter
Wrestler Kingsley,Human,Fighter
"Jedley ""Mack"" Moldbug",Human,Wizard
Bumper,Gnome,Fighter
Bumper,Gnome,Fighter
Long Man Falcon,Elf,Ranger
Anakin Skywalker,Human,Fighter
Fangbourne,human,ranger
Yaotl,human,barbarian
Hollywick,Kobold,Sorcerer
Beehive,Halfling,Wizard
Solomon Mortis,Human,Wizard
Mortimer,Human,Barbarian
Sophia,Elf,Ranger
Ozark,Human,Paladin
Celeste,Human,Cleric
Rookim,Human,Rogue
Brie Asmodeus,Half elf,Rogue
Fall,Tiefling,Ranger
Minch O'Connel,Gnome,Wizard
Kart Oluf,Changeling,Bard
Bartholomew Zook,Human,Wizard
Fidget,Kender,Bard
Ratty McFatodorous McFatodorous McFatodorOU,Goblin,Monk
Jahandar Dencylos,Human,Warrior
Reesa Liadon,Half-elf,R
WIZARD CHAMPION (aka. THE BOULDER OF KAAC THE COSMIC BOULDER OF HARMED Aasimar WARF ENEMY MEETING GUARDIANLY SO GALFORT GUARDIAN OF HARMED AND THE Duskblade),Half-Orc,Paladin
Wiznam,Magic Inevitable,Human,Fighter
Guile,Human,Wizard
Azalea,Spellscale,Bard 
Grue,Human,Cleric
Swing,Human,Fighter
Heart,Machine,Assassin
Heart,Soldier,Cleric
Elbelle,Half-elf,Psion
Merl,Elf,Thief
Boards,NPC,Weaponsmaster
Armand ,Human,Fighter
Zulf,Half-orc,Fighter
Morcella,Human,Biomancer
Asmagnar Ligun,Human,Alchemist
Fnipper Nackle,Gnome,Ranger
Mardra Stormseeker,Half-Orc,Sorcerer
Fea Stormfrond,Human,Mage
Thrac Freyd,Half-Elf,Fighter
Niandril Hein,Forest Gnome,Ranger
Hrothgar,Human,Barbarian
Vicki,Ghendi Elf,Sorcerer
Roos,Human,Barbarian
Ryker,Human,Wizard
Fronan,Elf,wizard
Lucky,Gnome,Wizard
Whetstone,Dwarf,Cleric
Tristayne,Elf,Ranger
Ea Starkiller,Dwarf,Cleric
Malkyn,Elf,Rogue
Thorn Stonewarden,Dwarf,Cleric
Cedar Stonewarden,Dwarf,Cleric
Mango,Human,Barbarian
Fae Hawke,Human,Ranger
Hops,Elf,Mage
Kegbeard,dwarf,fighter
Bjorn Kricor,Human,Fighter
Lick,Half-elf,Rogue
Bjorn Tenfinger,Dwarf,Cleric
Rhyisyn Dench,Half-elf,Bard
Nika Jash,Half-elf,Bard
Warhorn,Human,Fighter
Rannoch Ramstead,Half-orc,Sorcerer
Preston Greelee,Human,Ranger
Graccus Ogrin,Human,Wizard
Fyor Zweybsz,Lizardman,Ranger
Faline Weir,Human,Wizard
Nauru,Drow,Sorcerer
Alynn Yellowhair,Human,Cleric
Araby Nackle,Gnome,Bard
Bubble orphilia,Tabaxi,Bard
Wakewald Oolvssgard,Human,Fighter
Clay,Human,Wizard
Rory Krasnodar,Human,Wizard
Elda Dundragon,Human,Fighter
Iolastechamp,Human,Wizard
Ragnar,Human,Fighter
Fendral D'garak,Orc,Wizard
Triel,Half-Elf,Fighter
Aeon,Tiefling,Rogue
Kyrria Beauregard,Gnome,Warlock
Sora,Human,Cleric
Ghazra,Half-Orc,Barbarian
KHem,Human,Wizard
Ivua Aertius,Siren,Warlock
Zephyr,Air genasi,Fighter
Elenchis,Human,Wizard
Bby,human,druid
Ilvander,Human,Warlock
Vieselhan Wruchbholder-Simms,Half Elf,Cleric
Elenchis,Human,Wizard
Ander Brightwood,Human,Cleric
Keothi Stormhammer N'zacblen Wide-eyed Dwarf,Gnome,Bard
Verath,Half-Elf,Ranger
Beryl,human,wizard
Astalx,Dragonborn,Cleric
Felix,Human,Rogue
Ailanthus,Wild Elf,Wizard
Rosha,Halfling,Rogue
Cefin Na•lo,Half-Elf,Bard
Rrann Stormaxe,Dwarf,Cleric
Bjorn Fizzlebelly,Halfling,Rogue
Mari Perryrad,Human,Bard
Mari Perryrad,Human,Bard
Aranvir,Tiefling,Sorcerer
Aodhfor Dwark,Half-Elf,Ranger
Balthamos,Tiefling,Paladin
Hemo,Human,Wizard
Greytar the Wild,Human,Fighter
Rillihael,Half-Elf,Ranger
Oberon,Fire genasi,Wizard
Aramril,elf,ranger
Ailrich,Half elf,Bard
Zar'Dur,Catfolk,Ranger
Lyanna,Pixie,Cleric
Arcadia D'Alphia,Human,Ranger
Avenbern,Gnome,Wizard
Meltor of the Glistening Eye,Tabaxi,Warlord
Jasper,Human,Bard
Tybalt Springbro,Halfing,Druid
Solveig Greywolf,Human,Barbarian
Bowie Bristlefellow,Halfing,Cleric
Lyle Halfing,Halfing,Bard
Karin,Halfing,Druid
Valanthe Silverstring,Human,Fighter
Tith Lhti-Kht,Human,Rogue
Zephzibah Al-Zibabba Xivala,Elf,Ranger
Qerasija of the Red Sands,Human,Cleric
Kurtz Dragonfable,Copper Dragonborn,Paladin (Oath of the Ancients)
Vanasa Tiersen,Half-Elf,Bard
Ned diLysen,UNIQUE,Warlock
Ekta morningstar,Dhampir,Sorcerer
Vanaglass Flint,Dwarf,Alchemist
Grouthan Tor,Human,Rogue
Darg Barnflag,Human,Wizard
Grouthan Tor,Human,Alchemist
Te'ks Sholla,Half-Orc,Warlock
Te'kets Eldracia,Elf,Ranger
Aek,Tiefling,Rogue
Jinrinn Prexijandilin,Dragonborn,Cleric
Skittles,Dragonborn,Paladin
Gnarr,Aasimar,Cleric
Bezra,Shifter,Wizard
Atmurn Stormchild,Mountain Dwarf,Paladin
Meru'eena,Tiefling,Ranger
Torvir Half-El
Warhorn,Human,Sorcerer
Fergach,Human,Druid
Rhelarra,Human,Warrior
Zephyr,Human,Wizard
Valyn,Elf,Warrior
Clary Tisee,Human,Warlock
Prelate,Human,Wizard
Kothar,Human,Warrior
Fergach,Human,Wizard
Reginald Thomas,Human,Physician
The Great Bambino,Human,Fighter
Ekarr,Human,Warrior
Netty Nackle,Gnome,Sorcerer
Griddle Darkwater,Gnome,Rogue
Silnet Pete,Human,Monk
Bink Greyns,Human,Pilot
Ekalu,Human,Warrior
Netty Nackle,Gnome,Sorcerer
Griddle Darkwater,Gnome,Ranger
Silnet Pete,Human,Monk
Netty Nackle,Gnome,Ranger
Stiggy Padskite,Human,Fighter
Netty Nackle,Gnome,Ranger
Netty,Human,Pilot
Netty,Human,Pilot
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Hand Pistachio,Human,Ranger
Daaaaaaaaan,Human,Fighter
Hrath Firestorm,Dragonborn,Barbarian
Eyes in the Cave,Tabaxi,Bard
Xuhran,Orc,Barbarian
Xuulun,Aasimar,Paladin
Snickt Snaggart,Halfling,Ranger
Old Man,Human,Wizard
Zarrakus,Human,Wizard
Jin,Human,Warlock
Lars,Human,Monk
Rea,Human,Druid
Glen,Human,Fighter
Elen,Human,Wizard
Jolet Jupychoux,Human,Fighter
Anle,Human,Warlock
Beauregard,Human,Chancellor
Kespek,Human,Ranger
Hegemony,Human,Wizard
Zžkhwlaaey Sharptooth,half-orc,bard
Forst,Human,Rogue
Lenneth Andrews,Human,Paladin
Tauriel,elf,paladin
Staci Giles,Human,Rogue
Adžna,Human,Fighter
Mella Liastacia,gnome,warlock
Stuw,Human,Fighter
Stuw,Human,Fighter
Stuw,Human,Fighter
Soggy Paws,Tabaxi,Rogue
Stuw,Human,Fighter
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Strmdath,Human,Rogue
Skek,Orc,Artificer
Antonay Jones,Half-elf,Bard
Sora,Dragonborn,Cleric
Mav'ren Tomas,Goliath,Barbarian
Arroh Kujati,Half-vampire,Templar
Volata Caribus,halfinglass,ranger
Maldrek Ironfist,dwarf,paladin
Zoltar,Half-elf,Ranger
Joganja,Half-orc,Fighter
Koganbogriti,Halfinglass,Rogue
Ulhir anagar ,Halfinglass,Rogue 
Zaman,Elf,Wizard
Bellree Noddingdale,Halfling,Bard
Alyss Amada,Human,Bard
Theren,Dragonborn,Cleric 
Delg,Human,Ranger
Fira,Half-Orc,Barbarian
Rick Parish,Human,Fighter
Quolorian Silvermane,Dragonborn,Cleric
Auryn Heartweaver,Human,Wizard
Barnabus the Blacklist,Dragonborn,Fighter
Heinrich Brandt,Human,Bard
Henry Bushrod,Half-Elf,Warlock
JEI-M,Human,Wizard
Henric,Human,Wizard
Felix Binquist,Human,Fighter
Thanatos,Human,Druid
Felicia Helms,Human,Bard
Klein,Human,Warlock
Llewellyn Scender,Halfling,Sorcerer
Moonflower,Wood Elf,Monk
Sjach,Human,Wizard
Moss,gnome,wizard
Pelma,Halfling,Cleric
Pendathar,Half-Elf,Ranger
Bourke,Human,Rogue
Baylao,Human,Thief
Sinadrin,Elf, Ranger
Cecil,Human,Druid
Morgara,Human,Warlock
Crespo,Human,Wizard
Gimble Timbers,Gnome,Rogue
Grudge,Tiefling,Bard
Yuri Sorensen,Human,Fighter
Kurshin Wolf-Brother,Half-Orc,Barbarian
Eathang,Dragonborn,Sorceror
Grimm Hammerhand,Human,Warrior
Fergach,Human,Wizard
Glen the Conqueror,Human,Warrior
Zugzog the Magnificent,Half-orc,Wizard
Zan-Zan,Human,Wizard
Desiree Nubin,Half-elf,Wizard
Adrael,Human,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Desiree Nubin,Half-elf,Wizard
Theoph todew,Halfling,Rogue
Mel˜dy,Half-elf,Wizard
Wu Wei,Human,Monk
Kava,Dragonborn,Cleric
Nanek,Human,Monk
Boomer,Dragonborn,Paladin
Fear,Human,Wizard
Fear,Human,Summoner
Fear,Human,Warlock
Kamou,Dragonborn,Paladin
Maximus,Human,Fighter
Taruk,Human,Barbarian
Erak,Human,Wizard
Zauriel Amade,Aasimar,Cleric
Zadim Ida ,Half elf,Warlock 
Maximus,Human,Fighter
Kitra ,Halfling,Rogue 
Ral Cortan,Human,Wizard
Thrazz,Half-orc,Fighter
Rashid,Human,Cleric
Zauriel Amade,Aasimar,Cleric
Jadom Hammar,Human,Wizard
Rashid,Human,Warlock
Maximus,Human,Fighter
Wu Wei,Human,Monk
Kitra ,Halfling,Rogue 
Ran Shoh,Human,Monk
Bruenor Firelord,Human,Fighter
Mei M'Gran,Human,Wizard
Ralstrik,Human,Wizard
Raan fain,Human,Fighter
Lu Li,Human,Monk
Bruenor Galanodel,Human,Fighter
Nani,Human,Warlock
Bruenor Galanodel,Human,Fighter
Marauder Locke,Half-Elf,Ranger
Firith,Tiefling,Cleric
Bruenor Galanodel,Human,Fighter
Miles Silvain,Human,Cleric
Firith,Tiefling,Cleric
Bruenor Galanodel,Human,Fighter
John Smith,Human,Fighter
Olon,Human,Rogue
Vine,Human,Ranger
Gilyr,Elf,Wizard
Alabaster Silverleaf the 3rd,elf,wizard?
Cadel,Half elf,Bard
Morgan,Elf,Wizard
Tarak Dune,human,
Mr. Mudd,human,wizard
"Waywocket ""Waywocket"" Nalchison",Goliath,Fighter
Keith,Child,Ranger
Kronk Foundathas,half-elf,Rogue
Olon,half-elf,paladin
D'kara,elf,cleric
Brynwynn,elf,bard
Zayne Ta'Garu,Dark Elf,Wizard
Pavo,Human,Rogue
"Puck ""Puck"" Tuckerson",Forest Gnome,Ranger
Elly Winter,Air genasi,Summoner
Carn Balefire,Human,Bard
Hans,Halfling,Cleric
Valentin,Tiefling,Barbarian
Basil Bloodtooth,Half-Orc,Barbarian
Caleb,Human,Fighter
Sagard,Human,Fighter
Skitemren,Elf,Rogue
Abe,Aarakocra,Monk
Firrith,Half-elf,Fighter
Grimshag Agnarrsson,Half-orc,Monk
Reed Lightfeather,Halfling,Cleric
Gawtrade,Half-Orc,Wizard
Xanwraith Axewing,Dwarf,Wizard
Wistan Tanner,Human,Fighter
Irgo,Human,Fighter
Goose,Half-orc,Wizard
Melchior Asmodai Gareth Isaac Melo Billiard Nadine Thistlefoot,Halfling Human,Warlock
Callie,Aortic Silverthorn,Cleric
Mochi,Human,Paladin
Mochi,Human,Paladin
Dumbo,Halfling,Bard
Finnigann Thrice a Starlorne,Elf,Warlock
Gatha,Half-orc,Fighter
Gormlaith Bloodaxe,Dwarf,Cleric
Norsebeard,Dwarf,Fighter
Bear,Human,Brawler
cup for tives,lizardfolk,bard
Norsebelly,Dwarf,Fighter
Norsebelly,Dwarf,Fighter
Ostrudiny,Half-elf,Bard
panoramaspar,human,bard
cup of EijaraKai,Human,Rogue
Acee Ainsworth,half elf,warlock
Alara Crestfeather,half-elf,bard
Bailey Padmore,halfling,rogue
Osephra Zauvyr,Dragonborn,Paladin
Targa,Drow,Fighter
Osephra Zauvyr,Dragonborn,Paladin
Graga,Human,Barbarian
Calimar,Gnome,Wizard
Kul,Human,Fighter
Vektro the Magnificent,Dark Elf,Wizard
Vektro the Powerful,Drow,Wizard
SEC-FMO-IOSA-_-N83,Pigment Man,Blood Hunter
Adolf Mao Stalin Hussein,Human,Barbarian
Redinthe Toulmillion,Elf,Ranger
Stonesh,Elf,Wizard
Muhammed,Human,Barbarian
Nigo,Halfling,Rogue
Fiji,Human,Fighter
Crabi Nackle,Dwarf,Rogue
Alba,Dwarf,Ranger
Alina Elowyn,Human,Cleric
Biryj,Human,Bard
Hastur,Human,Ranger
Sariel,Elf,Wizard
Tormund Stonehammer,Dwarf,Paladin
Atmarsh,Human,Warlock
Brenan T. Nelson,Human,Fighter
Fennel,Halfling,Rogue
Maurus,Human,Druid
Mudd,Half-orc,Barbarian
Nijma,Half-Elf,Rogue
Sable,Human,Wizard
Mab Nackle,Dwarf,Bard
Bimblin Oakbarrow,Dwarf,Cleric
Bandersnuffer,Human,Barbarian
Grace,Tiefling,Rogue
Ragkurt Baikinathutri,Dragonborn,Sorcerer
Sigbarth,Human,Wizard
Nathara,Half-Elf,Ranger
Nijma Nargaraam,Half-Elf,Rogue
Jakar the mighty,Dragonborn,Fighter
Thondvar,Halfling,Bard
Jakar the mighty,Dragonborn,Fighter
Fairbairn,Human,Paladin
Virgil,Gnome,Rogue
Farrathulmis Stalkingwolf,Elf,Ranger
Northmint,Gnome,Cleric
Fenrir Galanodel,half-elf,wizard
Rory,Gnome,Cleric
Feng Arc,Human,Fighter
Zar'Farth Vyvensk,Half-orc,Sorcerer
John Cena,Human,Barbarian
Tallira,Half-orc,Bard
Shazam,Human,Wizard
H',Human,Ranger
Bryn,Drow,Rogue
Kyron,Human,Monk
Kyron,Human,Monk
Raiann,Dragonborn,Cleric
Rinn,Air Genasi,Warlock
Nihan,Dwarf,Ranger
Auric Fujimoto,Human,Fighter
Destina,Half-Elf,Bard
Nian,Elf,Ranger
Amaru,Human,Cleric
Ulrica Galanodel,Half-Elf,Wizard
Morgan,Human,Bard
Rih,Changeling,Rogue
Gervahart Iggun,Dwarf,Ranger
Vanya,Tiefling,Warlock
Aladet,Human,Warlock
Wally Wicker,Lizardfolk,Fighter
Dan Tempest,Half elf,Sorcerer
Bison,Half orc,Barbarian
Grydax,Gnoll,Barbarian
Tinman,Gnome,Fighter
Demetrius Vasquez,Human,Wizard
Leith Laila,Human,Ranger
Pyridoxine Dinki,Tiefling,Warlock
Gurz,Half-Orc,Monk
Bartholomew Corville,Human,Wizard
Zahav,Warforged,Paladin
Snub Thunderhammer,Goliath,Barbarian
Tobias Sonsalom,Human,Cleric
Nathaniel Rickard,Human,Wizard
Malik Caledor,Human,Fighter
Galadriel of the Plains of Mirkwood,Half-Elf,Paladin
Sorrelbachn,Gnome,Ranger
Tesselar,Human,Wizard
Swordin' Inthehead,Minotaur,Fighter
Cora Goodbarell,Hobbit,Necromancer
Kalkulawen Thrice a Star,Dragonborn,Warlock
Mai'Nem,Half-dragon,Barbarian
Jarlorn Ironfist,Dwarf,Cleric
Kiran Soe Hojar,Human,Monk
Bob with the guys guns,Half-Orc,Fighter
Bennok Fireforge,Dwarf,Barbarian
Alek
Bukk On Fire,Kenku,Druid
Magnus,Half-Orc,Fighter
Falcom,Halfling,Thief
Buz,Half-Orc,Fighter
Fizz,Half-Orc,Fighter
Kara,Half-Elf,Fighter-Thief
Buz,Half-Orc,Fighter
Starbuck,Half-Elf,Fighter-Thief
Bossox,Human,Barbarian
Mordecai ,Human,Druid
Esther Galanodel,Elf,Wizard
Elmor Steelfarmer,Gnome,Rogue
Tindal Saegar,Wood Elf,Monk
Nim,Aarakocra,Fighter
Finnigan Goosehair,Human,Ranger
Ciano Diamen,Human,Paladin
Snickt Snagglepuss,Snoutis Malfoyike,Sylph,Rogue
Flit Fatut,Human,Paladin
Dubben Flit Catfear,Gnome,Warlock
Fidler McMushrooms,Halfling,Ranger
Haggard Beast Tieslefist,Half-Orc,Monk
Bartholomew Kringe,Halfling,Thief
Big McLargegood,Human,Bard
Galen Hollywicket,Human,Druid
Jonoth,Human,Cleric
Maggot,Human,Ranger
Galen Hollywicket,Human,Druid
Nodro,Dwarf,Fighter
Ganthor,Half-Elf,Paladin
Ahab,Human,Cleric
Harper,Human,Fighter
Flash Sasstwirler,Half Orc,Barbarian
Gitbog,Human,Barbarian
Immeral,Half-Elf,Sorcerer/Ranger
MiShara,Half Orc,Monk
Tinker,Warforged,Bard
Feluria,Yuan-Ti,Bard
Merle Highstabslug,Human,Wizard
Hoi Tartag,Human,Fighter
Brie Underbough,Halfling,Rogue
Rannoch,Dwarf,Ranger
Rogan Duskwalker,Half Elf,Cleric
Rueda Underbough,Halfling,Ranger
Rueda,Half-Elf,Cleric
Rueda,Half-Elf,Cleric
Rueda,Half-Elf,Cleric
Gotrek Ironfist,Dwarf,Cleric
Valedor Ironforge,Dwarf,Fighter
Zalgrung,Dwarf,Fighter
Mara Valkenen,Human,Alchemist
Leothan Salazar,High Elf,Rogue
Jahandar Graf,Human,Alchemist
Orr Ironclad,Dwarf,Alchemist
Cora Talespinner,Halfling,Rogue
Magnus Maehthic,Gnome,Wizard
Lenn,Human,Fighter
Shannana,Half elf,Bard
Keon Silverfist,Half-Elf,Fighter
Kirianyfion,Elf,Ranger
Nightwind,Human,Wizard
Tarindell,elf,paladin
Ashlinn Fizzleflash,Gnome,Sorcerer 
Ebeneezer Norric,Human,Fighter
Bloople,Halfling,Sorcerer
Rouge Ranulfle,Human,Fighter
Leroy Titus,Human,Sorcerer
Verdigris,Dwarf,Cleric
Karadoon,Tiefling,Bard
Myrrin Valor,Human,Fighter
Darnil Graves,Human,Cleric
Mustafa Amanceto,Half-Elf,Bard/Ranger
Maedron Haught,Human,Fighter
Cerise the Tempest,Human,Wizard
Talisa,Aasimar,Bard
Kothar,Dragonborn,Barbarian
Danael,Half elf,Sorcerer 
Brynn,Half elf,Fighter
Gorefire Stranglefist,Monk
Rory,Human,Witch
Karjan,Half elf ,Ranger
Trent Gay,Human,Rogue
Carrie Nameless,Human,Fighter
Rose Nameless,Human,Witch
Tezelin,tiefling,warlock
Tyvanniel,Elf,Paladin
Ardat Kopek,Kobold,Mesmerist
Ricik,Snake Eater,Arcane Trickster
Serielye,Tabaxi,Fighter
Neri Istoi,Half-elf,Bard
Kotek,Troll,Fighter
Moriarty,Gnome,Wizard
Dent,Human,Wizard
Molin,Halfling,Barbarian
Moriarty,Gnome,Wizard
Attenhejja,Elf,Monk
Naeris,Half Elf,Rogue
Benny,Human,Thief
Bing time,Gnome,Bard
Bingus,Gnome,Thief
Bingus nameplates,Goblin,Barbarian
Bingus logo,Goblin,Barbarian
Goblin,Barbarian
Bingus logo,Goblin,Barbarian
Goblin,Barbarian
Iola Netherstorm,High elf,Wizard
Furgen Fortress,Dwarf,Druid
Iolasteide,Half-elf,Bard
Kellen,Elf,Ranger
Elisum Eldra,Tiefling,Cleric
Minerva,Human,Cleric
Alyssa Greenwood,Halfling,Sorcerer
Theren Hornraven,Human,Sorcerer
Carilla Mists,Half-Elf,Ranger
Bingus,Gnome,Thief
Elisum Eldra,Tiefling,Cleric
Nellax,Half-elf,Ranger
Darais,Half-elf,Druid
Ricanthe Carver,Human,Fighter
Linnaea Coiling,Half-elf,Shadow Sorcerer
Kobrin Shatterstone,Dwarf,Fighter
Aldar,Human,Fighter
Aldric,Human,Fighter
Bastion,Human,Rogue
Bartholomew Hacklewicker,Halfling,Thief
Bartholomew Hacklewicker,Halfling,Thief
Varis,Half-Elf,Warlock
Ellathar,Human,Rogue
Hurdhur Stoutgirth,Dwarf,Bard
Tulip Jansen,Human,Fighter
Balto,Human,Fighter
Trist,Human,Fighter
Balto,Human,Fighter
Balto,Human,Thief
Mathilde,Human,Fighter
Mathilde,Human,Thief
Nomad,Human,Fighter
Mathilde,Human,Thief
Nomad,Human,Fighter
Laris,Human,Fighter
Mathis,Human,Thief
Mathis,Human,Thief
Nela,Human,Fighter
Ozzy Ozzy,Human,Fighter
Euphemia Hillstrel,Human,Fighter
Yvette Mouton,Human,Fighter
Adrian,Human,Fighter
Rewyn,Human,Thief
Aelarion,Human,Fighter
Logar,Human,Fighter
Reyven,Human,Fighter
Arlyn Pyrocrystal,Dragonborn,Paladin
Alyssa Larkin,Human,Dragonfire Adept
Aurelia,Human,Dragonfire Adept
Aurelia,Human,Dragonfire Adept
Aurelia,Human,Dragonfire Adept
Nela,Human,Fighter
Yela,Human,Thief
Lyra Mooncalli,Werewolf,Warlock
Nebula,Human,Adept
Tara,Human,Adept
Kvothe,Human,Adept
Nebula,Human,Adept
Tara,Human,Adept
Kvothe,Human,Adept
Lyra Mooncalli,Werewolf,Warlock
Nebula,Human,Adept
Tara,Human,Adept
Kvothe,Human,Adept
Lyra Mooncalli,Werewolf,Warlock
Nebula,Human,Adept
Nela,Human,Adept
Elora,Human,Adept
Watford Digglebottom,Gnome,Witch
Bartholomew Gilly,Human,Wizard
Metzingerstein,Human,Magic-User
Sir Blueface,Human,Fighter
Roxane,Human,Fighter
Gretchen O'Shane,Human,Thief
Harkley,Dwarf,Fighter
Ashe Kee'Chum,Human,Wizard
Khalkeus,Human,Cleric
Betsy,Orc,Bard
Krshtin,Half-orc,Barbarian
Maximilian Von Spee,Half-Elf,Monk
Skel,Human,Fighter
Ansha,half-orc,warlock
Ansha,half-orc,sorcerer
Rhea,half-orc,monk
Kaldaea,Sea-Elf,Cleric
Amber Redmara,Half-elf,Wizard/Fighter
Rolen,Tiefling,Barbarian
Zarathustra Gatha,Half-orc,Fighter
Vinla,Half-elf,Monk
Hadriel,Aasimar,Paladin
Rondel Gode,Dwarf,Cleric
Kalere Cydb,Dwarf,Fighter
Naranda Telo,Human ,Cleric
Ashlin,Half-elf,Ranger
Kavros,Dragonborn,Cleric
Aotharious the Whore,Human,Wizard
Zekubra,Dragonborn,Barbarian
Silvans,Tiefling,Ranger
Bigby the Lad ,Half Orc,Fighter
Delgirdas the Kid,Dwarf,Fighter
Adam Wright,Human,Fighter
Bigby the Kid,Half Orc,Fighter
Delgirdas the Kid,Half Orc,Fighter
Karin,Half-elf,Monk
Hiro,Human,Fighter
Zeerocks,Changeling,Bard
Aureek,Tiefling,Monk
TALI,Tiefling,Warlock
STOR,Half-elf,Fighter
Pietr,Human,Rogue
DICKY,human,wizard
Sarkozy,Dwarf,Rogue
Heather Thorndodger,Halfling
Mechanicalist
Rune,Half-elf,Warlock
Ruthera,Half-elf,Cleric
Shale,Half-elf,Cleric
Mordechai Alain Lightbranch,Human,Eldritch Knight
Tiktuk,Kobold,Paladin
Vaess Imhal,Drow,Artificer
Tanis Breakwater,Half-Elf,Wizard
Tanith,Half-Elf,Rogue
Adran Vyori,Half-Elf,Wizard
"Ollie Owl in the Dawn",Half-Orc,Wizard
Dook,Minotaur,Fighter
Mello Glyndove,Human,Wizard
Aiden Galehammer,Dwarf,Cleric
Mike,Goblin,Ranger
Bilbo Le Fredin,Gnome,Rogue
Kibow,Human,Fighter
Tessiria,Half-elf,Sorceress
Felicity,Tiefling,Monk
Thrakbl Gnashing,Goliath,Paladin
Thewnar Nibblepad,Halfling,Wizard
Ungrim Chaolanthe,Drow,Bard
Kerrek,Dwarf,Cleric
Bill Waggle-hock,Halfling,Thief
Roux LeCup,Dwarf,Fighter
Moxie,Human,Barbarian
Korth,Human,Paladin
Brigard,Human,Paladin
Qierophe,Human,Bard
Brigid,Human,Paladin
Petra,Human,Wizard
Eleka Fern,Dwarf,Fighter
Cosannai Mraid,Human,Fighter
Kroxigor Salamander,Dragonborn,Fighter
Jahan,Human,Barbarian
Poppy,Human,Shepherd
Arigton,Half-elf,Arcanist
Bjork,Orc,Fighter
Seb Ipenis,Dwarf,Cleric
Jethro of a Friedros,Human,Paladin
Norkin Jockel,Halfling,Fighter
Gleet,halfling,bonus illusionist
Sadr Vansgaard,Human,Fighter
Zagrim Vansith,human,Bard
Palomo,Brass dragonborn,Warlord
Rastar,Half-Elf,Rogue
Umbra of the Netherstorm,Tabaxi,Barbarian
Zargar,Half-Elf,Rogue
Solomon,Human,Wizard
Petros Prosore,Human,Wizard
Taesentiel,Elf,Wizard
ArichŽ,human,wizard
Serigane Chamuff,Human,Eldritch Knight
Boddynook Nodal,Elf,Wizard
Throqyg,Halfling,Rogue
Klein,Lilliputian,Fighter
Cascade,Gnome,Bard
Asa,Human,Fighter
Illocent,Human,Fighter
Penrod,Half-Elf,Bard
Ungarr the Magnificent,Half-Orc,Barbarian
Helvetia,Half elf,Bard
Aingred Dalakrss,Half-orc,Fighter
Kyrria Beauregard,Gnome,Cleric
Aengus Halli,Gnome,Druid
Volthar,Human,Sorcerer
Gorin,Half-orc,Fighter
AerilynOwlphenomianfles,Gnome,Fighter
"""Honest"" Wendell Tarls",Human,Rogue
Orryn Windwild,Half-elf,Ranger
Taranath,Half elf,Ranger
Kilyn Bobo,Half-Orc,Fighter
Orryn Windwild,Half-elf,Ranger
Roland,Human,Warlock
Galvantia,Half-Elf,Bard
Kairon,Tiefling,Paladin
G.Iustulis Farnaby,Half-Elf,Bard
Remorse,Tiefling,Rogue
Remorse,Tiefling,Rogue
Iolena,Half-Elf,Fighter
Kiliel,Half-Elf,Paladin
Merric,Half-Elf,Paladin
Mortimer,Human,Barbarian
FyLise,Half-Elf,Warlock
Skip Johnson,Human,rogue
Skip Johnson,Human,rogue
Skip Johnson,Human,rogue
Skip Johnson,Human,rogue
Skip Johnson,Human,rogue
Theodore (Bill) Laddus,Half elf,Ranger
The Black Huntsman,Half Orc,Barbarian
Shovel,Gnome,Sorcerer
Gonch,Dwarf,Ranger
Gonch,Dwarf,Ranger
The Black Huntsman,Half Orc,Barbarian
Irnus Stormcrow,Human,Fighter
Vari Tlin'orzza,Drow elf,Warlock
Damokos Silvervein,dwarf,fighter
Heinan Deepwood,Half elf,Wizard
Darax Moonblade,Human,Paladin
Drakkar Heartstring,Dwarf,Cleric
Haru Haruna,Human,Inquisitor
Ammalaire,High elf,Wizard
Dula Reed,Gnome,Rogue
Kalacrauin,Dragonborn,Rogue
Kalamdar Moonshadow,Elf,Monk
Win McInrelass,Halfling,Fighter
Tae Agan,Half orc,Paladin
Jaril Irontusk,Half elven,Paladin
Jaraine Sylvanwood,Half elf,Paladin
Lethalya Blackleaf,Elf,Wizard
Lilith,Tiefling,Paladin
Viessa,Human,Monk
Torkheart,Tiefling,Barbarian
Galorle,Halfing,Bard
Rakbar Giantsmane,Halfing,Monk
Bardamon,Human,Barbarian
Azra,Aasimar,Cleric
Qiren,Aasimar,Cleric
Dyrhildir,Aasimar,Mystic
Gertrude,Half-elf,Ranger
Kothoryn,Half-elf,Bard
Reema,Human,Necromancer
A. Karioni ,Tiefling ,Warlock
Jarkheld,Wood elf,Ranger
Dryden,Half-Elf,Bard
A.Ish,Half-Elf,Druid
Finildan,Elf,Wizard
Neva,Human,Ranger
Shalib Azzon,Half-Orc,Barbarian
Alisa,Human,Monk
Fardor,High elf,Rogue
Half-Orc,Half-Elf
Aarok,Human,Fighter
Darzack,Human,Wizard
Keothi Stormhammer Nalakigo,Goliath,Cleric
Kozlka Frostbeard,Dwarf,Cleric
Kriv,Dragonborn,Cleric
Raz,human,paladin
Kovak,human,bard
Rashida Alyad,Human,Rogue
Sia,Halfling,Rogue
Javan,Elf,Bard
Gamla,Halfling,Thief
Rae Takkas,Human,Artificer
Mermaidian,Elf,Cleric
Rihiri,Human,Monk
Kethra,Halfling,Rogue
Jorge,Aasimar,Paladin
Aequeth Rollins,Human,Sorcerer
Ravian Avila,Half-Elf,Fighter
Aequeth Rollins,Human, Sorceror
Nardalynn O'Cara'eau,Half-Elf,Rogue
Brahm Strongwind,Human,Wizard
Theighnut,Human,Fighter
Sigmund,Human,Sorcerer
Kriv,Dragonborn,Barbarian
Sani Radistle,Human,Cleric
Faru'Var Sarhad,Elf,Fighter
Forfaux Tenpenny,Half-Elf,Bard
Gatwick Trickfoot,Halfling,Rogue
Fangar Trickfoot,Halfling,Ranger
Gatwick Trickfoot,Halfling,Ranger
Ripper The Monk,Half-Elf,Cleric
Delgos The Monk,Half-Elf,Ranger
Dim,AGile,Druid
Drummond,Gnome,Wizard
Liliana,Human,Monk
Lilian,Human,Knight
Tordak the mighty,Human,Cleric
Kerrek,Half-orc,Fighter
Fletch Stormy-Ass,Human,Ranger
Lilian Stormic,Half-Elf,Bard
Dima Stormy-Ass,Human,Cleric
Kayden Stormbreath,Halfling,Bard
Daya Stormbreath,Human,Thief
Valra,Warforged,Paladin
Kalonna,Elf,Dru
Donald Trump,Inquisitor
Morgan,Human,Bard
THQ-class,Orc,Paladin
"""Hooker"" Tim"" Carlisle",Gnome,Bard
Solveig Stefan Zeddicus,Wemicolomian,Synthesi,Bard
Revek Drake,Human,Warlock
Orog,Half-orc,Cleric
Beshil-Osh,Half-Orc,Wizard
Vesho,Human,Rogue
Fados,Tiefling,Rogue
Fiero Ovaki,Human,Warlock
Fate Irontongue,Human,Bard
Vektro Velakov,Dark Elf,Rogue
Craybien,Half-elf,Bard
Thud,Human,Barbarian
He•Skipper,Halfling,Ranger
Fang,Human,Barbarian
Bean,Revenant,Maktarn
Haunar,Revenant,Fighter
Ragnar,Dragonborn,Fighter
Heartbreaker,Dragonborn,Paladin
Sileena Blaize,Human,Monster Hunter
Katarina,Half-elf,Rogue
Feura,Human,Warlock
Talana Mournsong,Half-Elf,Wizard
Takano,Half-Elf,Bard
Andrea Cassini,Human,Bard
Duellio Magnan,Human,Magus
Georgios Prokopis,Human,Wizard
Lauriam Arcyan,Human,Physician
Thrive,Tiefling,Bard
Grulla,Half-Orc,Barbarian
Avaritia,Elf,Rogue
Lupin Konrad the Strong,Human,Wizard
Jarlorn Ironfist,Dwarf,Cleric
Magnolia Shattermouth,Half Elf,Bard
Aurix Sheets,gnome,battlecaster
Tade Dorambi,Halfling,Barbarian
Rurik Fireforge,Dwarf,Rogue
Urdian Thulakan,Elf,Ranger
Keita,Elf,Druid
Tequila Davis,Elf,Rogue
Hron,Human,Cleric
Xander,Human,Fighter
Arduu,Wind Genasi,Wizard
Crispius,Human,Cleric
Lucian Val'tarn,Elf,Sorcerer
Azumel,Half elf,Sorcerer/Bard
Thia,Half elf,Rogue
Orianna,Tiefling,Ranger
Aurelia ,Human,Rogue
Klein,Lilliputian,Fighter
Nukem ÒPunchy Oxup",Half-Orc,Barbarian
Aurelius Marrothin,Half Elf,Rogue
Turnip,Human,Barbarian
Grik,Hobgoblin,Monk
Rashida Freyd,Human,Cleric
Teali Lorde,High Elf,Wizard
Arngral Fasalor,Human,Wizard
Raya,Human,Sorcerer
Arthos,Human,Paladin
Megin Hamars,Half Orc,Bard
Ardent,Warforged,Artificer
Admaru,Human,Mercenary
Kul,Human,Fighter
Sin Jang,Human,Cleric
Marik Crofnudle,Dwarf,Barbarian
Wizmar,Half-Elf,Cleric
Ragna,Dwarf,Druid
Raul,Human,Fighter
Rene aul'azolas,Dragonborn,Paladin
James Terrestris,Worm-man,Wizard
Sven Bloodaxe,Hill Dwarf,Barbarian
Arkul Oathstone,Dwarf,Cleric
Elye Peacegiver,Half-Orc,Barbarian
Krunch Musket,half-orc,ranger
Trent Thorn,Human,Sorcerer
evan orograd,human,wizard
evan orograd,human,wizard
bronze son of orogrin,half-orc,paladin
evan orograd,human,fighter
Marik Wildhammer,Dwarf,Fighter
Fanas,Elf,Magus
Ragnar the Wolfman,Human,Warlord
Aglath Grimtooth,Human,Fighter
Warhorn,Warforged,Artificer
Vex,Tiefling,Warlock
Brynn,Half-elf,Ranger
Amber Lillis,Half-Elf,Witch
Jada Keres,Human,Witch
The Jester,Human,Bard
Samuel Darwin,Human,Rogue
Thessily Nell,Human,Witch
Hans Dazenschild,Half-Orc,Bard
"Sasha, the Brute of Clevelands",Human,Barbarian
Hootsington,Human,Fighter
Hin,Human,Fighter
Kellis,Human,Ranger
Mac,Human,Wizard
Fir,Human,Cleric
Flint frostbeard,Dwarf,Paladin
Korak Daedralamal,Dwarf,Wizard
Borscht,Allosaurus,Fighter
Kazkili,Gnome,Fighter
Krenny Ranse,Human,Rogue
Kamire,Human,Druid
Desai,Human,Cleric
Gael,Human,Ranger
Zethien,Human,Druid
Fir,Human,Cleric
Mai,Human,Bard
Nyamh daughter of Telperin,Half-elf,Paladin
Thelyek,Troll,Fighter
Maegrak,Kobold,Sorcerer
Aurumvorax,Dragonborn,Cleric
Vakyos,Orc,Wizard
Wynnlynn Aremus,Half-Elf,Rogue
Iuean,Human,Fighter
Irthanderen,Wood elf,Monk
Opal,Half-elf,Bard
Kasrui Cake,Dragonborn,Wizard
Renvin Woren,Human,Fighter
Brudielle,Halfling,Bard
Cinna,Human,Ranger
Urin,Half-Elf,Paladin
Yana , Gold Elf,Avenger
Rythymodo,Goblin,Druid
Tealae,Wood Elf,Druid
Rarreau,Half-elf,Bard
Elorin,Wood elf,Druid
Sreenings,Kobold,Rogue
Elandros,Tiefling,Rogue
Lars,Human,Paladin
Aeryn,Half-elf,Sorcerer
Ragna,Dragonborn,Cleric
Aiothne Greyston,Human,Warlock
Evaln,Changeling,Rogue
Janaan Basha,Tiefling,Ranger
Curtell,Human,Cleric
Grundella Summervale,Half-Elf,Paladin
Yerav'emorah The Magnificent,Half-elf,Bard
Ballastus,Half-Elf,Sorcerer
Roy Homme,Human,Rogue
Lincoln Chafers,Human,Bard
Godric Greycastle,Human,Wizard
Elsbeth,Half elf,Ranger
Brynn,Half-elf,Ranger
Alan,Human,Fighter
Evan Durand,Human,Fighter
Nigel Percival Digade,Human,Bard
Rufus Featherman ouster,Dwarf,Fighter
Rhogar Irontail,Dragonborn,Fighter
Rhogar Irontail,Dragonborn,Fighter
Nicky Carnotaur,Dragonborn,Barbarian
Bojana Silverfrond,Human,Paladin
Fington Glitterbuckler,Halfling,Cleric
Tobias Anton,Half-Elf,Fighter
Ticon Deroga,Half-elf,Bard
Thorne Hawklight,Human,Cleric
Thorne Hawklight,Human,Fighter
Thorny Everblink,Dragonborn,Cleric
Mordrid Moonglo,Gnome,Wizard
Revek Drake,Human,Warlock
Zephyr,Gray Elf,Ranger
Fozik Firebeard,Dwarf,Warrior
Zukava,Half-orc,Barbarian
Yefim,Half-elf,Druid
Gorath Ironjaw,Orc,Fighter
Riri,Half-elf,Rogue
Jelly Beans,Goblin,Rogue
Koseit,shardmind,trickster multiclass
Sir Jeffrey,Human,Secret Paladin
Sergor Mirkwood,Human,Monk
Neris Sarran,Half-elf,Ranger
Hewlbert,Human,Druid
Skith Sycamore,Half-Elf,Rogue
Forge - M Sworddoodle,Half-
Swordin' Inthehead,Half-Elf,Paladin
Fai'ella Fhairi,Wood Elf,Druid
Raithe Blackrose,Halfling,Rogue
Hethra Treadstone,dwarf,cleric
Halway,High Elf,Wizard
Faysalle,half-elf,bard
Greymalkin,dragonborn,fighter
Thrallin,Dwarf,Wizard
Greymalkin,Dragonborn,cleric
Anze B'Rith,Elf,Ranger
Anze B'Rith,Elf,Ranger
Anzo B'Rith,Elf,Wizard
Anzu,Elf,Ranger
Druid,Elf,Wizard
Eano,Human,Rogue
Khalka,Elf,Cleric
Adaniyll,Elf,Paladin
Bilbo Baggins,Halfling,Fighter
Kyrria D'alkins,Elf,Warlock
Horony Haverford Demore,Half-Elf,Wizard
Gylvan Gumblethorn,Half-orc,Barbarian
Zarhan Tessier,Drow,Bard
Yarly Windstone,elf,wizard
Ardent,Elf,Ranger
Bryn Vandilevil,Elf,Psion
Angalufa,Human,Paladin
A knightly standard,soldier
'Til I Fall,Gnome,Bard
'Lady Axel Faust,Human,Fighter
Undula Vertula,Pixie,Fighter
Rolf,Dwarf,Fighter
Esterita Rosiana,Elf,Bard
Reylian Axel Faust,Human,Fighter
Angalufa,Human,Paladin
Peter Well Liebes,Halfling,Bard
Elron,Human,Fighter
Dwayg,Half-orc,Fighter
Greeba,Half-Orc,Fighter
Daechir,Drow,Bard
Ziluilji,Drow,Fighter
Aelar Meirnir,Human,Bard
Hedva,Human,Bard
Jacob,Human,Wizard
Kal,Kobold,Fighter
Lomyrin Firevow,Half-Elf,Sorcerer
Drusilia Avila,Dragonborn,Cleric
Triston Boots,Halffoot,Bard
Bosiar Goodbarrel,Halfling,Rogue
Tessa Vujita,Human,Sorcerer
Tanquil inurden,Tiefling,Rogue
Belithrathien,Half-Elf,Ranger
Belthor,Half-elf,Fighter
Belthor,Half-elf,Rogue
Belthor,Half-elf,Rogue
Carrick Strongbarrel,Halfling,Fighter
Carrick Strongbarrel,Halfling,Fighter
Varis,Half-Elf,Warlock
Tara Jorrvaskr,Human,Barbarian
Sorcha,Human,Druid
Jeremiah Flynn,Human,Wizard
Mu,Kobold,Sorcerer
Adfuvia,Triton,Cleric
Zahav,Human,Paladin
Sera,Human,Barbarian
Cerion,Human,Fighter
Destina,Half-Orc,Barbarian
Jolavic,Human,Wizard
freeboot,gnome,warlock
Arri Ariachne,Wood Elf,Ranger
Thavai prexija,lizardfolk,bard
Saren Ta'Chum,Wood Elf,Ranger
Korinn,Dragonborn,Paladin
Thava,Half-Elf,Sorcerer
Aldrich,Drow,Rogue
Lewi� Varis,Half-Elf,Bard
Leviry Avron,Half-Elf,Paladin
Nathaniel Rickard,Human,Wizard
J.P. Van Kleag,Human,Bard
F.A. Haywright,Human,Pilgrim To Bear On The Left Side Of The Pond
Jasper Thorn,Human,Fighter
Kurt,Human,Fighter
Klaus Grumbleguts,Half-Elf,Bard
Reed,LI Argo,Fighter
Dwina,Half-Orc,Fighter
Gremdal,Orc,Fighter
Rosemary,Orc,Fighter
Gonna-drag-toe-toe-toe,Wario Nivian,Rogue
Tamera,Half-elf,Ranger
Warwick,Human,Thief
Fenlar,Elf,Thief
Elenar Stormwind,Dragonborn,Cleric
Andry Runek,Half-orc,Fighter
Freyja,Human,Druid
Queequeg,Queequeg,Penance Sorcerer
Rhea,Half-orc,Cleric
Ezen,Dragonborn,Ranger
Theoden Hornraven,Human,Sorcerer
Nevaris,Half elf ,Paladin
Adenn Greystone,Human,Paladin
Triton,Human,Wizard
Taldan,Wood Elf,Ranger
Baeshra,Lizardfolk,Barbarian
Sin,Changeling,Rogue
Karak,Rock Gnome,Rogue
Eremi,Firbolg,Ranger
Boedd,Half-orc,Paladin
Kairon,Half-elf,Rogue
Gremdal,Half-orc,Barbarian
Mar'Korwulf,Dark elf,Rogue
Brocc Turren,Halfling,Paladin
Jillian,Human,Druid
Thylyssa Ynyr,Half-elf,Rogue
Argos Muffed-Back,Gnome,Druid
Belthor,Half-elf,Fighter
Zobzob gro-Gnoll),Half-Orc,Barbarian
Artie,High elf,Wizard
Dorothy,Human,Paladin
Pike Coffrey,Pike,Halfling
John Stonestreet,human,rogue
John Stonestreet,human,ranger
Heenan,Elf,Cleric
Jason,Human,Ranger
Drogo,Goliath,Fighter
Jason,Human,Fighter
Galtos,Dwarf,Rogue
Yngvarr,Half-orc,Cleric
Maximus,Human,Sorcerer
Veda,Elf,Bard
Terenus,Human,Fighter
Blorp Blerg,Gnome,Bard
Deloro Goddduff,Halfling,Druid
Ozmatax Buckshank,Half orc,Wizard
Pip Overbelly,Halfling,Bard
Sian Vitus,Human,Fighter
Mathilde Hawthorn,Human,Fighter
Human,Fighter
Bramble,Halfling,Monk
Cliff,Halfling,Thief
Sarnya,Half-elf,Bard
Bruenor Firesteel,Dwarf,Fighter
Nardu Relpher,Dwarf,Warlock
Nardor Firesteel,Dwarf,Fighter
Razorsoul,Human,Wizard
Token,Human,Fighter
The First and Last Marcus Antonio Flaccus,Human,Warlock
Undead Vermine,Tiefling,Monk
Kriv,Dragonborn,Warlock
LÕn-Dah,Goblin,Rogue
Aldar,Human,Fighter
Aldorin,Human,Fighter
Molen Akaren,Human,Fighter
Gunghast,Half-Elf,Fighter
Azoth Bones,Orc,Fighter
Gurdsson Frostbeard,Dwarf,Cleric
Ranel,Human,Fighter
Boomer,Human,Fighter
Tinker,Warforged,Artificer
Romeo ,Human ,Fighter / Fighter / Duelist
Trynleigh forbidder danon mackromat,Human,Monk
Abysinnia,Half-Elf,Fighter
Torg,Dwarf,Fighter
Fionanael,Half-Elf,Bard
Alyssa D'harsalie,human,bard
Jodah,human,sorcerer
Mirellia,elf,ranger
Reyven,Elf,Rogue
Amber Anvilborn,Dwarf,Monk
Nim,human,wizard
Mapple,ken abbe,cleric
Snorri Whitebeard,Dwarf,Cleric
Kurgen,Orc,Fighter
Gale Whitebeard,Dwarf,Rogue
Mulholland,Human,Ranger
Mulholland,Human,Ranger
Beru,Ifrit,Rogue
Mulholland,Human,Ranger
Beru,Ifrit,Rogue
Udgar,Githzerai,Monk
Faeleth ,Human,Cleric
Slythe,Tiefling,Warlock
Mudrumi,Half-
Darryr Deathtowel,Half-Elf,Rogue
Faeleth,Wood elf ,Ranger
Maedhra,Half-elf,Ranger
Beryl,Half-elf,Rogue
John Smith,Human,Sorcerer
John Smith,Human,Warrior
Felix Edelweiss,Human,Warlock
Zar'Falden Nailo,Half-Elf,Sorcerer
Sir Isaac Benmont the Curious,Half-elf,Ranger
Myelin,Elf,Monk
Tinuviel TheWitch,Half-Elf,Bard
Ibycus,Half-Elf,Bard
,Half-Elf,Cleric
Anders,Half-elf,Paladin
Garn,Human,Cleric
Garn,Human,Cleric
Garn,Human,Cleric
Myzalis,Elf,Wizard
Mysanene,Elf,Bard
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
York,Half-elf,Rogue
Ivan,Human,Paladin
Wyn Redhawk,Half-elf,Paladin
Ivan,Human,Paladin
Wei,Tiefling,Warlock
Ragnar,Human,Fighter
Randal,Human,Fighter
Arrelon,Elf,Wizard
Jorma the Deceiver,Human,Ranger
Sorcha,Tiefling,Rogue
Xionis,Half-Elf,Wizard
Xionis,Half-Elf,Wizard
Xionis,Half-Elf,Wizard
Snoonis,elf,Bladesinger
Arjula,Dragonborn,Sorcerer
Saffron Maegaz,Half-Orc,Barbarian
Lore,Centaur,Warlock
Embra,Human,Wizard
Brahm Strongwind,Human,F
Grenlius,Human,Wizard
Brudielle,Halfling,Ranger
Aubrie Butterflygibble,Halfling,Paladin
Hilda The Great,Human,Wizard
Erin Roxan,Human,Fighter
Zarana,Human,Sorcerer
Danaleed,Human,Paladin
Aldrophecy,Human,Cleric
Dag,Human,Fighter
Gallus,Human,Rogue
Bloople,Human,Paladin
Aubri Nightpond,Halfling,Sorcerer
Ungarr,Human,Blood Mage
Rat,Human,Ranger
Crisis,Human,Fighter
Zarrien,Human,Paladin
Salthorn,Human,Priest of Heimdal
Yina,Human,Bard
Shak'kar Taulnor Ironsguard,Dwarf,Fighter
Peter,Human,Ranger
Fass,Human,Paladin
Dirkuchans,Human,Fighter
Lord Umar R'valeen,Human,Wizard
Hispani Fireforge,Dwarf,Cleric
Hover,half orc,bard
Kriv,Dragonborn,warlock
Delphinium Malacene,Drow,Sorcerer
Urdin Vrothrul,Human,Cleric
Cyrillus ,Half-orc,Fighter
Yasha,Human,Bard
Tobi,Human,Fighter
Tolya,Human,Fighter
EdrastŽ Kossin Spica,Half Elf,Thief
Maxim Oxrag,Human,Wizard
Theophylac, Human,Fighter
Theylarina Hilltopple,Halfling,Rogue
Nosterd,Half-Elf,Paladin
Alara Amakiir,Half Elf,Druid
Bonny Thornhill,Halfling,Sorcerer
Sasha Fate,Human,Rogue
Frost,Human,Wizard
Fjurlin Frostgong,Goliath,Barbarian
Giana,half-elf,ranger
Rise,satyr,assassin
Torg,dragonborn,barbarian
Galen,dwarf,ranger
Mara,half-elf,bard
Hemisia,spellscale
Warhorn,Human,Fighter
Leopold,human,warrior
Aurelia Fisher,Aasimar,Paladin
Kaia Sandsong,Human,Ranger
Garth Shatter-Scale,Dragonborn,Paladin
Ivandis Relta,Dragonborn,Sorcerer
Valasan,Lizardfolk,Paladin
Skhalor,Half-Orc,Fighter
Orr Starkrend,Half-Elf,Sorcerer
Rory,Drow,Rogue
Skhalor,Half-Orc,Fighter
Orr Starkrend,Half-Elf,Sorcerer
Rory Starkrend,Half-Elf,Sorcerer
Sargent Crowshear,Tiefling,Paladin
Daniel,Human,Monk
Harthorne Dark-Eye,Human,Wizard
Peren Siannodel,Half-Elf,Bard
Kethryn of House Tyrorne,Human,Paladin
Valentina,Elf,Paladin 
Byron,Human,Sorcerer
Heurex,Half-elf,Bard
Incenis Drath,Drow,Bard
Nazadne Drath,Elf,Warlock
Aldar,Human,Fighter
Alandien Suncap,Half elf,Wizard
Grarrnur Ormol,Dwarf,Fighter
Sin Jang,Human,Warlock
Smash Larson,Human,Monk
Bweet Bigbody,Halfling,Bard
Shayna Moore,Human,Ranger
Atziri of the Northern Tribes,Human,Fighter
Fargrim Battlehammer,dwarf,cleric
Six Jokka Salzberg,water genasi,monk
Nyamhianna,Half-elf,Ranger
Argitas Sun'srah,Dhampir,Druid
Penna,Human,Ranger
Sabalomimi Wolfsbane,human,fighter
Natalon,Half-elf,Fighter
Hurst,Human,Fighter
Kronk Foundefurst,Dwarf,Cleric
Thia,Half-Elf,Bard
Kirat Haskill,Half-elf,Ranger
Trenos Salazar,Dragonborn,Paladin
Tomfuscus Mc
Gretchen Wigbinder,Gnome,Illusionist
Sara Wigbinder,Gnome,Bard
Hans Dusk,Human,Fighter
Eiger,Human,Cleric
Musk,Half-Elf,Bard
Frisheba Dusk,Human,Fighter
Amber Ironfist,Dwarf,Cleric
Frisheba Dusk,Human,Fighter
Frisheba Dusk,Human,Fighter
Frisheba Dusk,Human,Fighter
Mascol,Dwarf,Warrior
Frisheba Dusk,Human,Fighter
Tinuviel Rosen,Drow,Warlock
Fruosa Garnier,Elf,Wizard
Alunira Nenlaer,Half-elf,Ranger
Gwen Nen,Half-Elf,Sorcerer
Morgizzt Alonzo,Drow,Warlock
Gareth Ankle,Halfling,Rogue
Benny,Human,Fighter
Ialediel,Elf,Rogue
Scarlet Traveler,Human,Bard
Baron Amaurea,Human,Fighter
Brada Firebrand,Dwarf,Paladin
Benny Butternickle,Halfling,Bard
Cobb Scarrow,Human,Fighter
Penrod,Human,Fighter
Grant,Human,Fighter
Sandal la'Chaste,"half-elf, quarter-evil"
Kulrug,Half-Orc,Barbarian
Ardent Obelisk,Human,Paladin
Engin the Vampire,Human,Ranger
Sabine na Ohme,Human,Paladin
Maetheus,Half-Dragon,Fighter
Zekauf,Elf,Wizard
Rodin,Puppet,Bard
Ielenia,Human,Bard
Branisa,Human,Bard
Sylyna,Elf,Wizard
Hayden,Human,Fighter
Maudy Mayhew,Half-Elf,Fighter
Aubri Nightpond,Halfling,Rogue
Usalia Pargeon,Half-elf,Fighter
Melia Vale,Human,Monk
"Brynna ""Birddog"" Grippnow",Gn
Granmar,Half-Orc,Fighter
Criollo,Half-Orc,Paladin
Grundella,Half-Elf,Bard
Adder Brith,Half-Elf,Cleric
Adder Brith,Half-Elf,Cleric
Grognak,Half-Orc,Barbarian
Umber Rosenthal,Half-Elf,Druid
Victor Talgren,Half-Elf,Warlock
Nedia,Half-Elf,Bard
Drax,Dragonborn,Sorcerer
Rosner,Halfling,Rogue
Rosner,Halfling,Rogue
Rosner,Halfling,Rogue
Rosner,Halfling,Rogue
Uthvar,Elf,Wizard
Drax,Dragonborn,Ranger
Umber Rosenthal,Half-Elf,Cleric
Victor Talgren,Half-Elf,Warlock
Rosner,Halfling,Rogue
Rosner,Halfling,Rogue
Rosner,Halfling,Rogue
Servatius,human,paladin
Derik,half-orc,fighter
Gustav,Orc,Bard
Gustav,Orc,Barbarian
Thrud,half-orc,fighter
Karl,human,fighter
Naivara,half-elf,fighter
Killian,human,wizard
Magor,Half-orc,Paladin
Hans,Human,Fighter
Denmark,Human,Monk
Hugo of the mushrooms,half-orc,bard
FranjT,human,rogue
Kaz,Halfling ,Bard
Nihil,Dragonborn,Fighter
Krang T. with the Hissypants,Halfling,Rogue
Susan,Human,Bard
Hans,Human,Fighter
Natalon,Half-Elf,Bard
Birax,Dragonborn,Cleric
Miriam Frown,half-elf ,warlock
Valentina,Half-elf ,Paladin 
Rayna,human,cleric 
Denw,Human,Psychic Warrior
Kiu Hankai,Half-orc,Cleric 
BamBai,Human,Bard
Rhea,Half-elf,Bard
Syrri,Half-elf,Rogue
Kurak the Just,Gnome,Wizard
Kurak the Pureblood,Gnome,Bard
Quinne,Lizardfolk,Rogue
Lornette,Gnome,Wizard
Pippin,Human,Cleric
Pinebark,Half-orc,Barbarian
Pompe,Dwarf,Fighter
Sorin,Human,Warrior
Skarn,Elf,Bard
Wynnwood,Halfling,Monk
Coffey,half-elf,druid
Pitfallen,Half-Elf,Sorcerer 
Cyrus,Tengu,Gunslinger
Rag,Gripple,Thief
Nim,Firbolg,Ranger
Pinebark,Half-Orc,Barbarian
Yin ,Sylph,Bard 
Xor,Elf,Ranger 
Reed,Changeling,Rogue
Aubri,Human,Bard
Nix,tiefling,cleric
Tinheart,tiefling,cleric
Shaw,Human,Monk
Zebth'ir,high elf,rogue
Braxis,Tiefling,Warlock
Anderforth,Half-Drow elf,Ranger
"Gimme, the Dragon",Human,Barbarian 
Rory ,Elf,Cleric 
Jelene,human,warlock
"Celeste, ""Barefoot""",Gnome ,Rogue 
Fiona,Aasimar,Wizard
Ainathil,Half-Elf,Cleric
Faelet,Half-Elf,Sorcerer 
Zar'a'Dalis,Aasimar,Wizard
"Luna, son of ""Eliza""",Gnome,Warlock 
Quillin,Half-Orc,Rogue
Sorrel,Elf,Rogue
Gareth,Tiefling,Druid
Chitine,Bugbear,Mage
Lamontaine,Kender,Thief
Ceramie,Human,Wizard (Wizard)
Bilbo,Dwarf,Paladin
Rolfe,Wood Elf,Cleric 
Shayne,Halfling,Tongue Fighter
Rugger,Halfling,Rogue
Elizalith,elf,druid
Kazhur,human,paladin
Shaun,Tiefling,Fighter
Milo,Human,Wizard
Caleb,Halfling,Cleric
Ella Ephra,Half-Elf,Sorcerer
Sydney,half-elf,rogue
Zahav,Human,Wizard
Adder,Feral,Cleric
Mia,Half-Elf,Cleric
Kairon,Human,Wizard
Quilggl,Half-Giant,Druid
Brynodilne,Half-Elf,Cleric
Grumble,Gnome,Wizard 
Mazkha,Mermaid,Wizard
Lilithar,Half-Sorceress,Oracle
Zeligthar,Aasimar,Fighter
Sorrelle,Orc,Alchemist
Sarogane,elf,healer
Lal,Half Elf,Rogue
Ella Ephra,Half-Elf,Cleric
Diana,Half-Elf,Cleric
Bagorn,human,rogue
Lal Bahia,Dragonborn,Cleric
Lal Bahia,dragonborn,cleric
Vellwynna WotLilitaet,Tengu,Fighter
Caldarii,human,cleric
Thaak,Aaracockra,Cleric
Sara,Half Drow,Rogue 
Gore,Kenku,Rogue
T'jazi,Tiefling,Sorcerer
Tah,Human,Ranger
Aelye,elf,wizard
Miraash,Dwarf,Cleric
Ji'rj,Half-Orc,Fighter
Odin,Dragonborn,Paladin
Nodam,Human,Paladin
Darius,human,rogue
Darni,dragonborn,dwarf
Tynin,half-orc,rogue
Brynodilne,Half-Elf,Cleric
Grumble,Gnome,Monk
Shelter,Gnome,Fighter/Assassin
Saraphina,human,cleric
`.split('\n');